/* CaseChile Product Customizer v3.0 */
(() => {
  'use strict';

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const qs = (root, selector) => root.querySelector(selector);
  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));

  function createSvg(name, attrs = {}) {
    const el = document.createElementNS(SVG_NS, name);
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    return el;
  }

  function parseBool(value) {
    return String(value) === 'true';
  }

  function combinedDeviceName(root, modelName) {
    return `${root.dataset.productTitle || ''} ${modelName || ''}`.toLowerCase();
  }


  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* Debutify / un campo antiguo de personalizacion puede inyectar un uploader
     fuera de nuestro configurador. En el template customizer lo ocultamos
     sin depender de una clase especifica del theme. */
  function hideElementCompletely(el) {
    if (!el || el === document.body || el === document.documentElement) return false;
    el.setAttribute('data-cc-legacy-uploader-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('max-height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('border', '0', 'important');
    return true;
  }

  /* Debutify / la personalizacion anterior inyecta un input file fuera de
     nuestro personalizador. Buscamos el bloque por texto, por input y por
     posicion relativa al customizer para eliminarlo de forma robusta. */
  function hideLegacyUploader(root) {
    const targetPhrase = 'sube aqui la imagen para tu carcasa';
    let hidden = false;

    // 1) Buscar primero el texto visible y subir hasta el contenedor que
    // tambien contiene el input file.
    const all = Array.from(document.body.querySelectorAll('*'));

    const textMatches = all
      .filter((el) => {
        if (root.contains(el)) return false;
        if (el.closest('[data-cc-legacy-uploader-hidden="true"]')) return false;
        const text = normalizeText(el.textContent);
        return text.includes(targetPhrase);
      })
      .sort((a, b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length);

    for (const match of textMatches) {
      let node = match;
      let depth = 0;

      while (node && node !== document.body && depth < 16) {
        const externalFile = Array.from(node.querySelectorAll('input[type="file"]'))
          .find((input) => !root.contains(input));

        if (externalFile) {
          const rect = node.getBoundingClientRect();

          // Evitar ocultar wrappers gigantes como main/body.
          if (rect.height > 0 && rect.height <= 260 && rect.width <= 1100) {
            hidden = hideElementCompletely(node) || hidden;
            break;
          }
        }

        node = node.parentElement;
        depth += 1;
      }
    }

    // 2) Fallback: cualquier file input externo situado justo antes del
    // customizer es el uploader antiguo de esta plantilla.
    const rootRect = root.getBoundingClientRect();

    document.querySelectorAll('input[type="file"]').forEach((input) => {
      if (root.contains(input)) return;
      if (input.closest('[data-cc-legacy-uploader-hidden="true"]')) return;

      const inputRect = input.getBoundingClientRect();
      const verticallyNear =
        inputRect.bottom <= rootRect.top + 60 &&
        inputRect.bottom >= rootRect.top - 500;

      if (!verticallyNear) return;

      let node = input.parentElement;
      let best = null;
      let depth = 0;

      while (node && node !== document.body && depth < 14) {
        const rect = node.getBoundingClientRect();
        const text = normalizeText(node.textContent);

        if (
          rect.height > 0 &&
          rect.height <= 220 &&
          rect.width <= 1000 &&
          (text.includes(targetPhrase) || node.querySelector('input[type="file"]'))
        ) {
          best = node;
        }

        if (text.includes(targetPhrase) && best) break;

        node = node.parentElement;
        depth += 1;
      }

      if (best) hidden = hideElementCompletely(best) || hidden;
    });

    return hidden;
  }

  function watchLegacyUploader(root) {
    hideLegacyUploader(root);

    if (!('MutationObserver' in window)) return;

    /* PERF: el callback se coalesce en un rAF para no re-ejecutar el
       barrido una vez por mutacion (el propio customizer muta el DOM). */
    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        hideLegacyUploader(root);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Algunas apps re-renderizan tarde. Dejamos chequeos breves.
    [300, 1000, 2500].forEach((delay) => {
      window.setTimeout(() => hideLegacyUploader(root), delay);
    });

    window.setTimeout(() => observer.disconnect(), 5000);
  }

  /* ═══════════════════════════════════════════════════════════════
     CAMERA_COORDS — 210 modelos verificados por el cliente
     Cada entrada: { x, y, w, h, rx } del recorte de cámara
     ═══════════════════════════════════════════════════════════════ */
  const CAMERA_COORDS = {
    // ── Apple ──────────────────────────────────────────────────
    'iphone 17 pro max':       { x: 40, y: 45, w: 277, h: 175, rx: 34 },
    'iphone 17 pro':           { x: 43, y: 43, w: 277, h: 156, rx: 32 },
    'iphone 17':               { x: 47, y: 45, w: 100, h: 159, rx: 28 },
    'iphone 17 air':           { x: 45, y: 56, w: 266, h: 90, rx: 24 },
    'iphone 17e':              { x: 48, y: 46, w: 142, h: 79, rx: 31 },
    'iphone 16 pro max':       { x: 44, y: 45, w: 149, h: 149, rx: 32 },
    'iphone 16 pro':           { x: 48, y: 46, w: 148, h: 149, rx: 30 },
    'iphone 16':               { x: 50, y: 53, w: 122, h: 122, rx: 26 },
    'iphone 16e':              { x: 49, y: 50, w: 138, h: 72, rx: 32 },
    'iphone 15 pro max':       { x: 42, y: 40, w: 149, h: 149, rx: 32 },
    'iphone 15 pro':           { x: 42, y: 42, w: 145, h: 148, rx: 30 },
    'iphone 15 plus':          { x: 45, y: 40, w: 118, h: 119, rx: 28 },
    'iphone 15':               { x: 50, y: 48, w: 118, h: 118, rx: 26 },
    'iphone 14 pro max':       { x: 46, y: 42, w: 148, h: 148, rx: 40 },
    'iphone 14 pro':           { x: 49, y: 51, w: 147, h: 147, rx: 30 },
    'iphone 14 plus':          { x: 46, y: 41, w: 125, h: 128, rx: 28 },
    'iphone 14':               { x: 48, y: 42, w: 129, h: 123, rx: 26 },
    'iphone 13 pro max':       { x: 42, y: 41, w: 141, h: 140, rx: 30 },
    'iphone 13 pro':           { x: 45, y: 44, w: 136, h: 135, rx: 30 },
    'iphone 13 mini':          { x: 49, y: 52, w: 120, h: 124, rx: 26 },
    'iphone 13':               { x: 45, y: 45, w: 119, h: 118, rx: 26 },
    'iphone 12 pro max':       { x: 43, y: 40, w: 132, h: 132, rx: 28 },
    'iphone 12 pro':           { x: 47, y: 45, w: 124, h: 124, rx: 28 },
    'iphone 12 mini':          { x: 53, y: 51, w: 100, h: 100, rx: 26 },
    'iphone 12':               { x: 44, y: 44, w: 110, h: 110, rx: 26 },
    'iphone 11 pro max':       { x: 43, y: 41, w: 130, h: 130, rx: 28 },
    'iphone 11 pro':           { x: 44, y: 44, w: 122, h: 122, rx: 28 },
    'iphone 11':               { x: 46, y: 43, w: 118, h: 118, rx: 26 },
    'iphone 7/8/se 2020':      { x: 47, y: 41, w: 114, h: 50, rx: 23 },

    // ── Samsung Galaxy S ──────────────────────────────────────
    'galaxy s26 ultra':        { x: 40, y: 41, w: 154, h: 236, rx: 22 },
    'galaxy s26 plus':         { x: 40, y: 41, w: 94, h: 190, rx: 24 },
    'galaxy s26':              { x: 45, y: 48, w: 80, h: 206, rx: 22 },
    'galaxy s25 ultra':        { x: 40, y: 41, w: 145, h: 234, rx: 20 },
    'galaxy s25 plus':         { x: 44, y: 38, w: 88, h: 209, rx: 24 },
    'galaxy s25':              { x: 47, y: 42, w: 82, h: 210, rx: 22 },
    'galaxy s25 fe':           { x: 47, y: 52, w: 90, h: 186, rx: 22 },
    'galaxy s24 ultra':        { x: 40, y: 43, w: 153, h: 234, rx: 20 },
    'galaxy s24 plus':         { x: 37, y: 41, w: 90, h: 190, rx: 24 },
    'galaxy s24':              { x: 44, y: 46, w: 83, h: 197, rx: 22 },
    'galaxy s24 fe':           { x: 44, y: 46, w: 86, h: 200, rx: 22 },
    'galaxy s23 ultra':        { x: 39, y: 40, w: 136, h: 235, rx: 20 },
    'galaxy s23 plus':         { x: 37, y: 37, w: 80, h: 211, rx: 24 },
    'galaxy s23':              { x: 42, y: 43, w: 81, h: 214, rx: 22 },
    'galaxy s23 fe':           { x: 43, y: 42, w: 89, h: 205, rx: 22 },
    'galaxy s22 ultra':        { x: 42, y: 41, w: 139, h: 247, rx: 20 },
    'galaxy s22 plus':         { x: 39, y: 39, w: 83, h: 213, rx: 24 },
    'galaxy s22':              { x: 44, y: 43, w: 85, h: 214, rx: 22 },
    'galaxy s21 ultra':        { x: 38, y: 38, w: 156, h: 245, rx: 30 },
    'galaxy s21 plus':         { x: 42, y: 43, w: 100, h: 215, rx: 28 },
    'galaxy s21':              { x: 44, y: 45, w: 91, h: 213, rx: 26 },
    'galaxy s21 fe':           { x: 49, y: 47, w: 94, h: 214, rx: 26 },
    'galaxy s20 ultra':        { x: 39, y: 38, w: 154, h: 240, rx: 28 },
    'galaxy s20 plus':         { x: 44, y: 42, w: 96, h: 200, rx: 26 },
    'galaxy s20':              { x: 45, y: 44, w: 90, h: 212, rx: 24 },
    'galaxy s20 fe':           { x: 44, y: 46, w: 111, h: 209, rx: 24 },

    // ── Samsung Galaxy A (parcial) ────────────────────────────
    'galaxy a73 5g':           { x: 41, y: 41, w: 105, h: 204, rx: 24 },
    'galaxy a12':              { x: 50, y: 48, w: 76, h: 153, rx: 20 },
    'galaxy a11':              { x: 42, y: 46, w: 77, h: 150, rx: 18 },
    'galaxy a10':              { x: 54, y: 47, w: 51, h: 110, rx: 14 },
    'galaxy a10s':             { x: 54, y: 47, w: 51, h: 110, rx: 14 },
    'galaxy a07':              { x: 50, y: 47, w: 66, h: 115, rx: 18 },
    'galaxy a06':              { x: 46, y: 46, w: 62, h: 124, rx: 18 },
    'galaxy a05':              { x: 51, y: 46, w: 70, h: 110, rx: 20 },
    'galaxy a05s':             { x: 51, y: 46, w: 70, h: 110, rx: 20 },
    'galaxy a04':              { x: 45, y: 46, w: 68, h: 108, rx: 18 },
    'galaxy a04s':             { x: 45, y: 46, w: 68, h: 108, rx: 18 },
    'galaxy a04e':             { x: 45, y: 46, w: 68, h: 108, rx: 18 },
    'galaxy a03':              { x: 45, y: 45, w: 66, h: 104, rx: 18 },
    'galaxy a03s':             { x: 45, y: 45, w: 66, h: 104, rx: 18 },
    'galaxy a03 core':         { x: 45, y: 45, w: 66, h: 104, rx: 18 },
    'galaxy a02':              { x: 44, y: 45, w: 64, h: 96, rx: 16 },
    'galaxy a02s':             { x: 44, y: 45, w: 64, h: 96, rx: 16 },
    'galaxy a01':              { x: 49, y: 42, w: 51, h: 81, rx: 14 },
    'galaxy a01 core':         { x: 49, y: 42, w: 51, h: 81, rx: 14 },

    // ── Honor ─────────────────────────────────────────────────
    'honor 400 pro 5g':                    { x: 52, y: 46, w: 178, h: 176, rx: 46 },
    'honor 400 5g':                        { x: 53, y: 44, w: 132, h: 221, rx: 46 },
    'honor 400 lite 5g':                   { x: 51, y: 43, w: 128, h: 200, rx: 51 },
    'honor 400 smart 5g':                  { x: 49, y: 48, w: 152, h: 174, rx: 22 },
    'honor x7d':                           { x: 49, y: 48, w: 152, h: 174, rx: 22 },
    'honor magic 8 lite 5g':               { x: 72, y: 53, w: 213, h: 217, rx: 97 },
    'honor magic 7 lite 5g':               { x: 73, y: 50, w: 212, h: 211, rx: 98 },
    'honor x9c':                           { x: 73, y: 50, w: 212, h: 211, rx: 98 },
    'honor magic 6 lite 5g':               { x: 72, y: 57, w: 210, h: 212, rx: 93 },
    'honor magic 5 lite 5g':               { x: 76, y: 50, w: 207, h: 208, rx: 95 },
    'honor x9c smart':                     { x: 86, y: 58, w: 187, h: 189, rx: 82 },
    'honor x8c':                           { x: 50, y: 48, w: 147, h: 167, rx: 22 },
    'honor x8b':                           { x: 47, y: 42, w: 161, h: 180, rx: 22 },
    'honor x8a 4g':                        { x: 47, y: 47, w: 162, h: 196, rx: 20 },
    'honor x8 4g':                         { x: 45, y: 46, w: 179, h: 186, rx: 20 },
    'honor x8 5g':                         { x: 45, y: 46, w: 179, h: 186, rx: 20 },
    'honor x8a 5g':                        { x: 45, y: 46, w: 179, h: 186, rx: 20 },
    'honor x6 5g':                         { x: 45, y: 46, w: 179, h: 186, rx: 20 },
    'honor x7c':                           { x: 46, y: 44, w: 170, h: 188, rx: 20 },
    'honor 200 smart':                     { x: 46, y: 44, w: 170, h: 188, rx: 20 },
    'honor x6b 5g':                        { x: 46, y: 44, w: 170, h: 188, rx: 20 },
    'honor x7b':                           { x: 43, y: 41, w: 119, h: 238, rx: 20 },
    'honor 90 smart':                      { x: 43, y: 41, w: 119, h: 238, rx: 20 },
    'honor x7a':                           { x: 43, y: 42, w: 98, h: 158, rx: 20 },
    'honor x7':                            { x: 48, y: 51, w: 78, h: 160, rx: 26 },
    'honor x6a':                           { x: 48, y: 47, w: 159, h: 163, rx: 18 },
    'honor x6a plus':                      { x: 48, y: 47, w: 159, h: 163, rx: 18 },
    'honor x6':                            { x: 47, y: 47, w: 160, h: 179, rx: 18 },
    'honor x6s':                           { x: 47, y: 47, w: 160, h: 179, rx: 18 },
    'honor x5c':                           { x: 52, y: 52, w: 138, h: 157, rx: 16 },
    'honor x5c plus':                      { x: 52, y: 52, w: 138, h: 157, rx: 16 },
    'honor x5b':                           { x: 46, y: 42, w: 150, h: 162, rx: 16 },
    'honor x5b plus':                      { x: 46, y: 42, w: 150, h: 162, rx: 16 },
    'honor 200 5g':                        { x: 45, y: 42, w: 122, h: 213, rx: 61 },
    'honor 200 lite 5g':                   { x: 47, y: 40, w: 128, h: 221, rx: 29 },
    'honor 90 5g':                         { x: 44, y: 41, w: 119, h: 235, rx: 59 },
    'honor 90 lite':                       { x: 52, y: 45, w: 112, h: 194, rx: 40 },
    'honor 70 5g':                         { x: 46, y: 44, w: 120, h: 223, rx: 60 },
    'honor 50 5g':                         { x: 47, y: 49, w: 118, h: 186, rx: 59 },

    // ── Xiaomi ────────────────────────────────────────────────
    'xiaomi 17 ultra 5g':                  { x: 73, y: 50, w: 209, h: 211, rx: 104 },
    'xiaomi 17t pro 5g':                   { x: 51, y: 41, w: 154, h: 183, rx: 43 },
    'xiaomi 17t 5g':                       { x: 46, y: 37, w: 171, h: 171, rx: 62 },
    'xiaomi 15 ultra 5g':                  { x: 74, y: 51, w: 212, h: 212, rx: 106 },
    'xiaomi 15t pro 5g':                   { x: 46, y: 43, w: 164, h: 164, rx: 31 },
    'xiaomi 15t 5g':                       { x: 46, y: 41, w: 147, h: 149, rx: 31 },
    'xiaomi 15 5g':                        { x: 46, y: 38, w: 138, h: 165, rx: 32 },
    'xiaomi mi 14 ultra':                  { x: 86, y: 51, w: 177, h: 180, rx: 86 },
    'xiaomi mi 14':                        { x: 45, y: 41, w: 154, h: 176, rx: 31 },
    'xiaomi mi 14t pro':                   { x: 47, y: 43, w: 142, h: 163, rx: 23 },
    'xiaomi mi 14t':                       { x: 45, y: 41, w: 138, h: 159, rx: 27 },
    'xiaomi mi 13t/13t pro':               { x: 54, y: 51, w: 140, h: 154, rx: 32 },
    'xiaomi mi 13t':                       { x: 54, y: 51, w: 140, h: 154, rx: 32 },
    'xiaomi mi 13t pro':                   { x: 54, y: 51, w: 140, h: 154, rx: 32 },
    'xiaomi mi 12t/12t pro':               { x: 46, y: 45, w: 125, h: 157, rx: 30 },
    'xiaomi mi 12t':                       { x: 46, y: 45, w: 125, h: 157, rx: 30 },
    'xiaomi mi 12t pro':                   { x: 46, y: 45, w: 125, h: 157, rx: 30 },
    'xiaomi mi 12 pro':                    { x: 41, y: 38, w: 101, h: 172, rx: 28 },
    'xiaomi mi 12':                        { x: 45, y: 44, w: 96, h: 170, rx: 26 },
    'xiaomi mi 12 lite':                   { x: 44, y: 48, w: 95, h: 170, rx: 22 },
    'xiaomi mi 11t/11t pro':               { x: 44, y: 43, w: 111, h: 173, rx: 26 },
    'xiaomi mi 11t':                       { x: 44, y: 43, w: 111, h: 173, rx: 26 },
    'xiaomi mi 11t pro':                   { x: 44, y: 43, w: 111, h: 173, rx: 26 },
    'xiaomi mi 11':                        { x: 41, y: 41, w: 132, h: 131, rx: 28 },
    'xiaomi mi 11 lite':                   { x: 47, y: 43, w: 117, h: 129, rx: 22 },
    'xiaomi mi 11 lite 5g ne':             { x: 47, y: 43, w: 117, h: 129, rx: 22 },
    'xiaomi mi 10t/10t pro':               { x: 50, y: 51, w: 90, h: 175, rx: 22 },
    'xiaomi mi 10t':                       { x: 50, y: 51, w: 90, h: 175, rx: 22 },
    'xiaomi mi 10t pro':                   { x: 50, y: 51, w: 90, h: 175, rx: 22 },
    'xiaomi mi 10t lite':                  { x: 99, y: 59, w: 154, h: 154, rx: 72 },

    // ── Redmi ─────────────────────────────────────────────────
    'xiaomi redmi note 15 pro plus 5g':    { x: 81, y: 47, w: 198, h: 198, rx: 81 },
    'redmi note 15 pro+ 5g':              { x: 81, y: 47, w: 198, h: 198, rx: 81 },
    'poco m8 pro':                         { x: 81, y: 47, w: 198, h: 198, rx: 81 },
    'xiaomi redmi note 15 pro 5g':         { x: 88, y: 46, w: 185, h: 188, rx: 67 },
    'redmi note 15 pro 5g':               { x: 88, y: 46, w: 185, h: 188, rx: 67 },
    'xiaomi redmi note 15 5g':             { x: 82, y: 52, w: 184, h: 187, rx: 61 },
    'redmi note 15 5g':                    { x: 82, y: 52, w: 184, h: 187, rx: 61 },
    'poco m8':                             { x: 82, y: 52, w: 184, h: 187, rx: 61 },
    'xiaomi redmi note 15 4g':             { x: 87, y: 54, w: 182, h: 184, rx: 50 },
    'redmi note 15 4g':                    { x: 87, y: 54, w: 182, h: 184, rx: 50 },
    'xiaomi redmi 15 5g':                  { x: 40, y: 42, w: 125, h: 216, rx: 22 },
    'redmi 15 5g':                         { x: 40, y: 42, w: 125, h: 216, rx: 22 },
    'xiaomi redmi 15c 5g':                 { x: 41, y: 41, w: 112, h: 171, rx: 20 },
    'redmi 15c 5g':                        { x: 41, y: 41, w: 112, h: 171, rx: 20 },
    'xiaomi redmi 15c 4g':                 { x: 39, y: 39, w: 132, h: 172, rx: 20 },
    'redmi 15c 4g':                        { x: 39, y: 39, w: 132, h: 172, rx: 20 },
    'poco c85':                            { x: 39, y: 39, w: 132, h: 172, rx: 20 },
    'xiaomi redmi note 14 pro plus 5g':    { x: 83, y: 54, w: 196, h: 199, rx: 86 },
    'redmi note 14 pro+ 5g':              { x: 83, y: 54, w: 196, h: 199, rx: 86 },
    'xiaomi redmi note 14 pro 5g':         { x: 84, y: 52, w: 194, h: 203, rx: 67 },
    'redmi note 14 pro 5g':               { x: 84, y: 52, w: 194, h: 203, rx: 67 },
    'poco x7 5g':                          { x: 84, y: 52, w: 194, h: 203, rx: 67 },
    'poco x7':                             { x: 84, y: 52, w: 194, h: 203, rx: 67 },
    'xiaomi redmi note 14 5g':             { x: 42, y: 40, w: 148, h: 165, rx: 22 },
    'redmi note 14 5g':                    { x: 42, y: 40, w: 148, h: 165, rx: 22 },
    'xiaomi redmi note 14 4g':             { x: 40, y: 41, w: 120, h: 160, rx: 22 },
    'redmi note 14 4g':                    { x: 40, y: 41, w: 120, h: 160, rx: 22 },
    'xiaomi redmi 14c 4g':                 { x: 79, y: 59, w: 199, h: 196, rx: 94 },
    'redmi 14c 4g':                        { x: 79, y: 59, w: 199, h: 196, rx: 94 },
    'poco c75':                            { x: 79, y: 59, w: 199, h: 196, rx: 94 },
    'xiaomi redmi note 13 pro plus 5g':    { x: 45, y: 40, w: 141, h: 170, rx: 19 },
    'redmi note 13 pro+ 5g':              { x: 45, y: 40, w: 141, h: 170, rx: 19 },
    'xiaomi redmi note 13 pro 5g':         { x: 46, y: 42, w: 130, h: 172, rx: 19 },
    'redmi note 13 pro 5g':               { x: 46, y: 42, w: 130, h: 172, rx: 19 },
    'poco x6 5g':                          { x: 46, y: 42, w: 130, h: 172, rx: 19 },
    'xiaomi redmi note 13 pro 4g':         { x: 39, y: 42, w: 134, h: 173, rx: 15 },
    'redmi note 13 pro 4g':               { x: 39, y: 42, w: 134, h: 173, rx: 15 },
    'poco m6 pro 4g':                      { x: 39, y: 42, w: 134, h: 173, rx: 15 },
    'poco m6 pro':                         { x: 39, y: 42, w: 134, h: 173, rx: 15 },
    'xiaomi redmi note 13 5g':             { x: 38, y: 40, w: 103, h: 160, rx: 22 },
    'redmi note 13 5g':                    { x: 38, y: 40, w: 103, h: 160, rx: 22 },
    'xiaomi redmi note 13 4g':             { x: 41, y: 39, w: 94, h: 150, rx: 20 },
    'redmi note 13 4g':                    { x: 41, y: 39, w: 94, h: 150, rx: 20 },
    'xiaomi redmi 13c 5g':                 { x: 39, y: 43, w: 109, h: 153, rx: 20 },
    'redmi 13c 5g':                        { x: 39, y: 43, w: 109, h: 153, rx: 20 },
    'xiaomi redmi 13c 4g':                 { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'redmi 13c 4g':                        { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'poco c65':                            { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'xiaomi redmi note 12 pro+ 5g':        { x: 51, y: 44, w: 122, h: 172, rx: 19 },
    'redmi note 12 pro+ 5g':              { x: 51, y: 44, w: 122, h: 172, rx: 19 },
    'xiaomi redmi note 12 pro 5g':         { x: 45, y: 45, w: 119, h: 156, rx: 20 },
    'redmi note 12 pro 5g':               { x: 45, y: 45, w: 119, h: 156, rx: 20 },
    'xiaomi redmi note 12 4g':             { x: 41, y: 39, w: 129, h: 153, rx: 20 },
    'redmi note 12 4g':                    { x: 41, y: 39, w: 129, h: 153, rx: 20 },
    'xiaomi redmi note 12 5g':             { x: 40, y: 39, w: 119, h: 146, rx: 22 },
    'redmi note 12 5g':                    { x: 40, y: 39, w: 119, h: 146, rx: 22 },
    'poco x5':                             { x: 40, y: 39, w: 119, h: 146, rx: 22 },
    'xiaomi redmi note 12s':               { x: 46, y: 45, w: 124, h: 141, rx: 20 },
    'redmi note 12s':                      { x: 46, y: 45, w: 124, h: 141, rx: 20 },
    'xiaomi redmi 12 5g':                  { x: 44, y: 42, w: 126, h: 139, rx: 20 },
    'redmi 12 5g':                         { x: 44, y: 42, w: 126, h: 139, rx: 20 },
    'poco m6 pro 5g':                      { x: 44, y: 42, w: 126, h: 139, rx: 20 },
    'xiaomi redmi 12 4g':                  { x: 40, y: 41, w: 118, h: 152, rx: 20 },
    'redmi 12 4g':                         { x: 40, y: 41, w: 118, h: 152, rx: 20 },
    'xiaomi redmi 12c':                    { x: 44, y: 44, w: 112, h: 137, rx: 18 },
    'redmi 12c':                           { x: 44, y: 44, w: 112, h: 137, rx: 18 },
    'xiaomi redmi note 11 pro plus':       { x: 37, y: 39, w: 94, h: 156, rx: 24 },
    'redmi note 11 pro plus':              { x: 37, y: 39, w: 94, h: 156, rx: 24 },
    'redmi note 11 pro+':                  { x: 37, y: 39, w: 94, h: 156, rx: 24 },
    'xiaomi redmi note 11 pro':            { x: 39, y: 42, w: 89, h: 145, rx: 22 },
    'redmi note 11 pro':                   { x: 39, y: 42, w: 89, h: 145, rx: 22 },
    'xiaomi redmi note 11':                { x: 38, y: 41, w: 81, h: 136, rx: 20 },
    'redmi note 11':                       { x: 38, y: 41, w: 81, h: 136, rx: 20 },
    'xiaomi redmi note 11s':               { x: 38, y: 41, w: 81, h: 136, rx: 20 },
    'redmi note 11s':                      { x: 38, y: 41, w: 81, h: 136, rx: 20 },
    'redmi note 11s 5g':                   { x: 41, y: 42, w: 82, h: 135, rx: 20 },
    'poco m4 pro 5g':                      { x: 41, y: 42, w: 82, h: 135, rx: 20 },
    'xiaomi redmi note 10 pro':            { x: 39, y: 41, w: 83, h: 135, rx: 22 },
    'redmi note 10 pro':                   { x: 39, y: 41, w: 83, h: 135, rx: 22 },
    'redmi note 10 pro max':               { x: 39, y: 41, w: 83, h: 135, rx: 22 },
    'xiaomi redmi note 10':                { x: 41, y: 43, w: 84, h: 134, rx: 20 },
    'redmi note 10':                       { x: 41, y: 43, w: 84, h: 134, rx: 20 },
    'xiaomi redmi note 10s':               { x: 41, y: 43, w: 84, h: 134, rx: 20 },
    'redmi note 10s':                      { x: 41, y: 43, w: 84, h: 134, rx: 20 },
    'poco m5s':                            { x: 41, y: 43, w: 84, h: 134, rx: 20 },
    'xiaomi redmi note 10 5g':             { x: 42, y: 41, w: 78, h: 133, rx: 20 },
    'redmi note 10 5g':                    { x: 42, y: 41, w: 78, h: 133, rx: 20 },
    'poco m3 pro':                         { x: 42, y: 41, w: 78, h: 133, rx: 20 },
    'xiaomi redmi 10 5g':                  { x: 45, y: 45, w: 75, h: 124, rx: 20 },
    'redmi 10 5g':                         { x: 45, y: 45, w: 75, h: 124, rx: 20 },
    'xiaomi redmi 10':                     { x: 48, y: 45, w: 85, h: 135, rx: 20 },
    'redmi 10':                            { x: 48, y: 45, w: 85, h: 135, rx: 20 },
    'xiaomi redmi 10c':                    { x: 43, y: 41, w: 130, h: 133, rx: 18 },
    'redmi 10c':                           { x: 43, y: 41, w: 130, h: 133, rx: 18 },
    'xiaomi redmi 9c':                     { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi 9c':                            { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi 10a':                    { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi 10a':                           { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi note 9 pro':             { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'redmi note 9 pro':                    { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'xiaomi redmi note 9s':                { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'redmi note 9s':                       { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'xiaomi redmi note 9':                 { x: 127, y: 62, w: 88, h: 120, rx: 20 },
    'redmi note 9':                        { x: 127, y: 62, w: 88, h: 120, rx: 20 },

    // ── POCO ──────────────────────────────────────────────────
    'xiaomi poco x7 pro 5g':               { x: 52, y: 45, w: 82, h: 162, rx: 40 },
    'poco x7 pro 5g':                      { x: 52, y: 45, w: 82, h: 162, rx: 40 },
    'poco x7 pro':                         { x: 52, y: 45, w: 82, h: 162, rx: 40 },
    'xiaomi poco f6 pro 5g':               { x: 40, y: 42, w: 280, h: 212, rx: 19 },
    'poco f6 pro 5g':                      { x: 40, y: 42, w: 280, h: 212, rx: 19 },
    'poco f6 pro':                         { x: 40, y: 42, w: 280, h: 212, rx: 19 },
    'xiaomi poco f6 5g':                   { x: 39, y: 37, w: 160, h: 183, rx: 46 },
    'poco f6 5g':                          { x: 39, y: 37, w: 160, h: 183, rx: 46 },
    'poco f6':                             { x: 39, y: 37, w: 160, h: 183, rx: 46 },
    'poco x6 pro 5g':                      { x: 43, y: 40, w: 276, h: 190, rx: 19 },
    'poco x6 pro':                         { x: 43, y: 40, w: 276, h: 190, rx: 19 },
    'xiaomi poco f5 pro':                  { x: 41, y: 35, w: 128, h: 177, rx: 31 },
    'poco f5 pro':                         { x: 41, y: 35, w: 128, h: 177, rx: 31 },
    'xiaomi poco f5':                      { x: 44, y: 38, w: 119, h: 156, rx: 27 },
    'poco f5':                             { x: 44, y: 38, w: 119, h: 156, rx: 27 },
    'poco x5 pro 5g':                      { x: 42, y: 45, w: 109, h: 158, rx: 24 },
    'poco x5 pro':                         { x: 42, y: 45, w: 109, h: 158, rx: 24 },
    'xiaomi poco x4 pro 5g':               { x: 39, y: 42, w: 281, h: 155, rx: 22 },
    'poco x4 pro 5g':                      { x: 39, y: 42, w: 281, h: 155, rx: 22 },
    'poco x4 pro':                         { x: 39, y: 42, w: 281, h: 155, rx: 22 },
    'xiaomi poco m5':                      { x: 48, y: 46, w: 81, h: 141, rx: 20 },
    'poco m5':                             { x: 48, y: 46, w: 81, h: 141, rx: 20 },
    'poco m4 pro 4g':                      { x: 40, y: 39, w: 96, h: 172, rx: 20 },
    'xiaomi poco m4 pro 4g':               { x: 40, y: 39, w: 96, h: 172, rx: 20 },
    'xiaomi poco f3':                      { x: 42, y: 41, w: 96, h: 162, rx: 22 },
    'poco f3':                             { x: 42, y: 41, w: 96, h: 162, rx: 22 },
    'xiaomi poco x3 gt':                   { x: 44, y: 42, w: 101, h: 166, rx: 22 },
    'poco x3 gt':                          { x: 44, y: 42, w: 101, h: 166, rx: 22 },
    'xiaomi poco x3':                      { x: 85, y: 62, w: 176, h: 116, rx: 22 },
    'poco x3':                             { x: 85, y: 62, w: 176, h: 116, rx: 22 },
    'poco x3 nfc':                         { x: 85, y: 62, w: 176, h: 116, rx: 22 },
    'poco x3 pro':                         { x: 85, y: 62, w: 176, h: 116, rx: 22 },
    'xiaomi poco m3':                      { x: 42, y: 44, w: 97, h: 146, rx: 22 },
    'poco m3':                             { x: 42, y: 44, w: 97, h: 146, rx: 22 },

    // ── Xiaomi Redmi extras ───────────────────────────────────
    'xiaomi redmi a5':                     { x: 40, y: 42, w: 125, h: 216, rx: 22 },
    'redmi a5':                            { x: 40, y: 42, w: 125, h: 216, rx: 22 },
    'xiaomi redmi 13x':                    { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'redmi 13x':                           { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'xiaomi redmi a3':                     { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'redmi a3':                            { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'xiaomi redmi a3x':                    { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'redmi a3x':                           { x: 42, y: 43, w: 112, h: 155, rx: 18 },
    'xiaomi redmi 9t':                     { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'redmi 9t':                            { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'xiaomi redmi 9a':                     { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi 9a':                            { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi 9':                      { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi 9':                             { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi a1':                     { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi a1':                            { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi a2':                     { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'redmi a2':                            { x: 45, y: 42, w: 141, h: 143, rx: 18 },
    'xiaomi redmi note 8 pro':             { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'redmi note 8 pro':                    { x: 127, y: 62, w: 89, h: 116, rx: 22 },
    'xiaomi redmi note 8':                 { x: 127, y: 62, w: 88, h: 120, rx: 20 },
    'redmi note 8':                        { x: 127, y: 62, w: 88, h: 120, rx: 20 },

    // ── Vivo ──────────────────────────────────────────────────
    'vivo v60 lite 5g':        { x: 45, y: 49, w: 92, h: 151, rx: 24 },
    'vivo v50 5g':             { x: 48, y: 43, w: 106, h: 203, rx: 53 },
    'vivo v50 lite 5g':        { x: 49, y: 48, w: 90, h: 272, rx: 30 },
    'vivo y39 5g':             { x: 42, y: 46, w: 88, h: 155, rx: 20 },
    'vivo y38 5g':             { x: 40, y: 38, w: 87, h: 147, rx: 20 },
    'vivo v40 se':             { x: 41, y: 41, w: 86, h: 154, rx: 22 },
    'vivo y04':                { x: 42, y: 41, w: 73, h: 153, rx: 18 },
    'vivo y29s 5g':            { x: 42, y: 41, w: 73, h: 153, rx: 18 },
    'vivo y03':                { x: 44, y: 41, w: 79, h: 142, rx: 18 },
    'vivo y18':                { x: 44, y: 41, w: 79, h: 142, rx: 18 },
    'vivo y28s':               { x: 44, y: 41, w: 79, h: 142, rx: 18 },
    'vivo v30':                { x: 46, y: 47, w: 121, h: 197, rx: 35 },
    'vivo v30 lite':           { x: 47, y: 48, w: 94, h: 185, rx: 22 },
    'vivo y19s':               { x: 46, y: 46, w: 84, h: 156, rx: 18 },
    'vivo y17s':               { x: 44, y: 40, w: 85, h: 146, rx: 18 },
    'vivo v29 5g':             { x: 47, y: 40, w: 154, h: 265, rx: 33 },
    'vivo y36 5g':             { x: 46, y: 44, w: 91, h: 149, rx: 20 },
    'vivo y27 5g':             { x: 46, y: 44, w: 91, h: 149, rx: 20 },
    'vivo y27 4g':             { x: 41, y: 41, w: 79, h: 149, rx: 20 },
    'vivo v25 pro':            { x: 50, y: 38, w: 140, h: 202, rx: 37 },
    'vivo v25 5g':             { x: 54, y: 41, w: 127, h: 171, rx: 32 },
    'vivo y35':                { x: 43, y: 40, w: 88, h: 160, rx: 20 },
    'vivo y22s':               { x: 43, y: 43, w: 91, h: 147, rx: 18 },
    'vivo y16':                { x: 43, y: 40, w: 77, h: 158, rx: 16 },
    'vivo y02s':               { x: 43, y: 40, w: 77, h: 158, rx: 16 },
    'vivo v21 5g':             { x: 46, y: 50, w: 95, h: 149, rx: 22 },
    'vivo y55 5g':             { x: 44, y: 45, w: 84, h: 152, rx: 20 },
    'vivo y51':                { x: 40, y: 41, w: 89, h: 135, rx: 20 },
    'vivo y53s':               { x: 40, y: 41, w: 89, h: 135, rx: 20 },
    'vivo y21s':               { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo y20':                { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo y11s':               { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo y20s':               { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo y01':                { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo y15s':               { x: 44, y: 43, w: 87, h: 185, rx: 18 },
    'vivo v20':                { x: 46, y: 47, w: 89, h: 145, rx: 20 },

    // ── OPPO ──────────────────────────────────────────────────
    'oppo reno 13f':           { x: 44, y: 45, w: 108, h: 170, rx: 24 },
    'oppo reno 12f':           { x: 74, y: 50, w: 197, h: 207, rx: 83 },
    'oppo a79 5g':             { x: 44, y: 41, w: 109, h: 199, rx: 11 },
    'oppo a78 5g':             { x: 53, y: 42, w: 74, h: 142, rx: 25 },
    'oppo a58 4g':             { x: 41, y: 42, w: 87, h: 142, rx: 20 },
    'oppo a38':                { x: 51, y: 51, w: 70, h: 129, rx: 18 },
    'oppo reno 10 5g':         { x: 48, y: 42, w: 81, h: 176, rx: 40 },
    'oppo find x5 pro':        { x: 35, y: 38, w: 151, h: 209, rx: 34 },
    'oppo a57':                { x: 46, y: 39, w: 84, h: 142, rx: 18 },
    'oppo a77':                { x: 46, y: 39, w: 84, h: 142, rx: 18 },
    'oppo a17':                { x: 59, y: 51, w: 66, h: 137, rx: 22 },
    'oppo reno 7 5g':          { x: 39, y: 39, w: 93, h: 147, rx: 22 },
    'oppo reno 7 4g':          { x: 46, y: 46, w: 91, h: 151, rx: 22 },
    'oppo reno 6 5g':          { x: 47, y: 46, w: 78, h: 114, rx: 22 },
    'oppo reno 6 lite':        { x: 45, y: 44, w: 86, h: 141, rx: 20 },
    'oppo a16':                { x: 53, y: 49, w: 122, h: 145, rx: 16 },
    'oppo a54':                { x: 46, y: 43, w: 89, h: 141, rx: 20 },
    'oppo reno 5 lite':        { x: 42, y: 43, w: 104, h: 164, rx: 20 },
    'oppo a15':                { x: 53, y: 49, w: 122, h: 145, rx: 16 },
    'oppo a5':                 { x: 46, y: 43, w: 89, h: 141, rx: 20 },
    'oppo a5 5g':              { x: 46, y: 43, w: 89, h: 141, rx: 20 }
  };

  /* Normaliza el nombre del modelo para buscar en CAMERA_COORDS */
  function normalizeCameraKey(modelName) {
    return String(modelName || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getGeometry(root, modelName) {
    const name = combinedDeviceName(root, modelName);

    // ── Body (silueta de la carcasa) ──
    let body = { x: 28, y: 28, w: 304, h: 704, rx: 58 };

    if (name.includes('fold') || name.includes('flip')) {
      body = { x: 40, y: 44, w: 280, h: 674, rx: 48 };
    } else if (name.includes('ultra') || name.includes('pro max') || name.includes('note')) {
      body = { x: 26, y: 24, w: 308, h: 710, rx: 50 };
    }

    // ── Buscar coordenadas verificadas ──
    const key = normalizeCameraKey(modelName)
      .replace(/\s*\d+(\.\d+)?[''']+\s*/g, ' ')  // quitar dimensiones "6.43''"
      .replace(/[''']+/g, '')                     // quitar comillas sueltas
      .replace(/\s+/g, ' ').trim();
    let verified = CAMERA_COORDS[key];

    // Modelos compuestos ("Honor X5C / X5C Plus") → probar primera parte
    if (!verified && key.includes('/')) {
      const firstPart = key.split('/')[0].trim();
      verified = CAMERA_COORDS[firstPart]
        || CAMERA_COORDS[firstPart.replace(/^xiaomi\s+/, '')];
    }

    // "Xiaomi Poco X6 Pro 5G" → probar sin prefijo "xiaomi "
    if (!verified && key.startsWith('xiaomi ')) {
      verified = CAMERA_COORDS[key.replace(/^xiaomi\s+/, '')];
    }

    if (verified) {
      // Ajustar el rx del body si la cámara está muy cerca de una esquina.
      // El anillo del recorte se extiende 3px más allá del hole, así que
      // verificamos con un margen de seguridad de 6px.
      var holeLeft   = verified.x - 6;
      var holeTop    = verified.y - 6;
      var holeRight  = verified.x + verified.w + 6;
      var holeBottom = verified.y + verified.h + 6;
      var bodyRight  = body.x + body.w;
      var bodyBottom = body.y + body.h;
      var maxRx = body.rx;

      // Para cada esquina cercana, resolver (rx-dx)² + (rx-dy)² ≤ rx²
      // Expandido: rx² - 2(dx+dy)rx + dx²+dy² ≤ 0
      // Raíces: rx = (dx+dy) ± √(2·dx·dy)
      // El punto está dentro del arco para rx ∈ [raíz menor, raíz mayor],
      // y para rx < raíz menor el punto NO está en zona de esquina (dx ≥ rx),
      // así que el máximo rx seguro es la raíz MAYOR.
      function maxRxForCorner(dx, dy) {
        if (dx <= 0 || dy <= 0) return Infinity;
        var product = 2 * dx * dy;
        if (product <= 0) return Infinity;
        return (dx + dy) + Math.sqrt(product);
      }

      // Esquina superior-izquierda
      var dxTL = holeLeft - body.x;
      var dyTL = holeTop - body.y;
      var rTL = maxRxForCorner(dxTL, dyTL);
      if (rTL < maxRx) maxRx = rTL;

      // Esquina superior-derecha
      var dxTR = bodyRight - holeRight;
      var dyTR = holeTop - body.y;
      var rTR = maxRxForCorner(dxTR, dyTR);
      if (rTR < maxRx) maxRx = rTR;

      if (maxRx < body.rx) {
        body = Object.assign({}, body, { rx: Math.max(8, maxRx) });
      }

      return {
        body,
        holes: [
          { type: 'rect', x: verified.x, y: verified.y, w: verified.w, h: verified.h, rx: verified.rx }
        ]
      };
    }

    // ── Fallback genérico por marca (modelos sin verificar) ──
    const x = body.x;
    const y = body.y;
    let holes = [];

    if (name.includes('iphone') && name.includes('pro')) {
      holes = [{ type: 'rect', x: x + 16, y: y + 14, w: 150, h: 150, rx: 30 }];
    } else if (name.includes('iphone')) {
      holes = [{ type: 'rect', x: x + 22, y: y + 16, w: 120, h: 120, rx: 26 }];
    } else if (
      name.includes('galaxy') || name.includes('samsung')
    ) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 90, h: 190, rx: 24 }];
    } else if (
      name.includes('motorola') || name.includes('moto')
    ) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 90, h: 160, rx: 34 }];
    } else if (name.includes('huawei')) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 110, h: 150, rx: 28 }];
    } else if (
      name.includes('xiaomi') || name.includes('redmi') || name.includes('poco')
    ) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 120, h: 155, rx: 22 }];
    } else if (name.includes('honor')) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 150, h: 175, rx: 22 }];
    } else if (name.includes('vivo')) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 85, h: 155, rx: 20 }];
    } else if (name.includes('oppo')) {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 90, h: 150, rx: 22 }];
    } else {
      holes = [{ type: 'rect', x: x + 18, y: y + 18, w: 106, h: 128, rx: 28 }];
    }

    return { body, holes };
  }


  const BRAND_RULES = [
    { name: 'Apple', patterns: ['iphone', 'apple'] },
    { name: 'Samsung', patterns: ['samsung', 'galaxy'] },
    { name: 'Xiaomi', patterns: ['xiaomi', 'redmi', 'poco'] },
    { name: 'Motorola', patterns: ['motorola', 'moto '] },
    { name: 'Huawei', patterns: ['huawei'] },
    { name: 'Honor', patterns: ['honor'] },
    { name: 'Vivo', patterns: ['vivo'] },
    { name: 'OPPO', patterns: ['oppo'] },
    { name: 'Realme', patterns: ['realme'] },
    { name: 'OnePlus', patterns: ['oneplus', 'one plus'] },
    { name: 'Google', patterns: ['google', 'pixel'] },
    { name: 'Nothing', patterns: ['nothing'] }
  ];

  const BRAND_PRIORITY = [
    'Apple',
    'Samsung',
    'Xiaomi',
    'Motorola',
    'Huawei',
    'Honor',
    'Vivo',
    'OPPO',
    'Realme',
    'OnePlus',
    'Google',
    'Nothing',
    'Otros'
  ];

  /* ══════════════════════════════════════════════════════════════
     MODEL_CATALOG — catálogo completo de modelos por marca.
     Fuente: listado entregado por el cliente (2026-08-17).
     ══════════════════════════════════════════════════════════════ */
  const MODEL_CATALOG = {
    Apple: [
      'iPhone 17', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone 17 Air', 'iPhone 17E',
      'iPhone 16', 'iPhone 16 Pro', 'iPhone 16 Pro Max', 'iPhone 16E',
      'iPhone 15', 'iPhone 15 Pro', 'iPhone 15 Pro Max', 'iPhone 15 Plus',
      'iPhone 14', 'iPhone 14 Pro', 'iPhone 14 Pro Max', 'iPhone 14 Plus',
      'iPhone 13', 'iPhone 13 Pro', 'iPhone 13 Pro Max', 'iPhone 13 Mini',
      'iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max', 'iPhone 12 Mini',
      'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max',
      'iPhone 7/8/SE 2020'
    ],
    Samsung: [
      // Galaxy A
      'Galaxy A01', 'Galaxy A01 Core', 'Galaxy A02', 'Galaxy A02s', 'Galaxy A03', 'Galaxy A03s', 'Galaxy A03 Core',
      'Galaxy A04', 'Galaxy A04s', 'Galaxy A04e', 'Galaxy A05', 'Galaxy A05s', 'Galaxy A06', 'Galaxy A07',
      'Galaxy A10', 'Galaxy A10s', 'Galaxy A11', 'Galaxy A12', 'Galaxy A13 4G', 'Galaxy A13 5G',
      'Galaxy A14 4G', 'Galaxy A14 5G', 'Galaxy A15 4G', 'Galaxy A15 5G', 'Galaxy A16 4G', 'Galaxy A16 5G',
      'Galaxy A17 5G', 'Galaxy A20', 'Galaxy A20s', 'Galaxy A21s', 'Galaxy A22 4G', 'Galaxy A22 5G',
      'Galaxy A23 4G', 'Galaxy A23 5G', 'Galaxy A24', 'Galaxy A25 5G', 'Galaxy A26 5G',
      'Galaxy A30', 'Galaxy A30s', 'Galaxy A31', 'Galaxy A32 4G', 'Galaxy A32 5G', 'Galaxy A33 5G',
      'Galaxy A34 5G', 'Galaxy A35 5G', 'Galaxy A36 5G', 'Galaxy A37 5G',
      'Galaxy A50', 'Galaxy A50s', 'Galaxy A51', 'Galaxy A51 5G', 'Galaxy A52 4G', 'Galaxy A52 5G', 'Galaxy A52s 5G',
      'Galaxy A53 5G', 'Galaxy A54 5G', 'Galaxy A55 5G', 'Galaxy A56 5G', 'Galaxy A57 5G',
      'Galaxy A70', 'Galaxy A71', 'Galaxy A71 5G', 'Galaxy A72', 'Galaxy A73 5G', 'Galaxy A80',
      // Galaxy J
      'Galaxy J8', 'Galaxy J6+', 'Galaxy J6', 'Galaxy J4+', 'Galaxy J4 Core', 'Galaxy J4', 'Galaxy J2 Core',
      'Galaxy J7 Duo', 'Galaxy J7 Neo', 'Galaxy J7 Pro', 'Galaxy J5 Pro', 'Galaxy J3 Pro',
      'Galaxy J7 Prime', 'Galaxy J5 Prime', 'Galaxy J2 Prime', 'Galaxy J2 Pro',
      'Galaxy J7 2016', 'Galaxy J5 2016', 'Galaxy J3 2016', 'Galaxy J1 2016',
      'Galaxy J1 Mini Prime', 'Galaxy J1 Mini', 'Galaxy J7', 'Galaxy J5', 'Galaxy J3', 'Galaxy J2', 'Galaxy J1 Ace', 'Galaxy J1',
      // Galaxy S
      'Galaxy S26', 'Galaxy S26 Plus', 'Galaxy S26 Ultra',
      'Galaxy S25', 'Galaxy S25 Plus', 'Galaxy S25 Ultra', 'Galaxy S25 FE',
      'Galaxy S24', 'Galaxy S24 Plus', 'Galaxy S24 Ultra', 'Galaxy S24 FE',
      'Galaxy S23', 'Galaxy S23 Plus', 'Galaxy S23 Ultra', 'Galaxy S23 FE',
      'Galaxy S22', 'Galaxy S22 Plus', 'Galaxy S22 Ultra',
      'Galaxy S21', 'Galaxy S21 Plus', 'Galaxy S21 Ultra', 'Galaxy S21 FE',
      'Galaxy S20', 'Galaxy S20 Plus', 'Galaxy S20 Ultra', 'Galaxy S20 FE'
    ],
    Xiaomi: [
      'Xiaomi 17 Ultra 5G', 'Xiaomi 17T Pro 5G', 'Xiaomi 17T 5G',
      'Xiaomi Redmi A7 Pro',
      'Xiaomi 15 Ultra 5G', 'Xiaomi 15T Pro 5G', 'Xiaomi 15T 5G', 'Xiaomi 15 5G',
      'Xiaomi Redmi Note 15 Pro Plus 5G / Poco M8 Pro', 'Xiaomi Redmi Note 15 Pro 5G',
      'Xiaomi Redmi Note 15 5G / Poco M8', 'Xiaomi Redmi Note 15 4G',
      'Xiaomi Redmi 15 5G', 'Xiaomi Redmi 15C 5G', 'Xiaomi Redmi 15C 4G / Poco C85',
      'Xiaomi Redmi A5', 'Xiaomi Poco X7 Pro 5G',
      'Xiaomi MI 14 ultra', 'Xiaomi MI 14', 'Xiaomi MI 14T Pro', 'Xiaomi MI 14T',
      'Xiaomi Redmi Note 14 Pro Plus 5G', 'Xiaomi Redmi Note 14 Pro 5G / Poco X7 5G',
      'Xiaomi Redmi Note 14 5G', 'Xiaomi Redmi Note 14 4G',
      'Xiaomi Redmi 14C 4G / Poco C75',
      'Xiaomi Poco F6 Pro 5G', 'Xiaomi Poco F6 5G',
      'Xiaomi MI 13T/13T Pro',
      'Xiaomi Redmi Note 13 Pro Plus 5G', 'Xiaomi Redmi Note 13 Pro 5G / Poco X6 5G',
      'Xiaomi Poco X6 Pro 5G', 'Xiaomi Redmi Note 13 Pro 4G / Poco M6 Pro 4G',
      'Xiaomi Redmi Note 13 5G', 'Xiaomi Redmi Note 13 4G',
      'Xiaomi Redmi 13C 5G', 'Xiaomi Redmi 13C 4G / Poco C65', 'Xiaomi Redmi 13x',
      'Xiaomi Redmi A3 / A3X',
      'Xiaomi MI 12T/12T Pro', 'Xiaomi MI 12 Pro', 'Xiaomi MI 12', 'Xiaomi MI 12 Lite',
      'Xiaomi Poco F5 Pro', 'Xiaomi Poco F5',
      'Xiaomi Redmi Note 12 Pro+ 5G', 'Xiaomi Redmi Note 12 Pro 5G', 'Xiaomi Redmi Note 12 4G',
      'Xiaomi Poco X5 Pro 5G', 'Xiaomi Poco X5 / Redmi Note 12 5G', 'Xiaomi Redmi Note 12s',
      'Xiaomi Redmi 12 5G/ Poco M6 pro 5G', 'Xiaomi Redmi 12 4G', 'Xiaomi Redmi 12C',
      'Xiaomi MI 11T / 11T Pro', 'Xiaomi MI 11', 'Xiaomi MI 11 Lite / 11 Lite 5G NE',
      'Xiaomi Poco F4 GT', 'Xiaomi Poco X4 Pro 5G', 'Xiaomi Poco M5',
      'Xiaomi Redmi Note 11 Pro Plus', 'Xiaomi Redmi Note 11 Pro',
      'Xiaomi Poco M4 pro 5G / Redmi Note 11S 5G', 'Xiaomi Poco M4 pro 4G',
      'Xiaomi Redmi Note 11 / 11S',
      'Xiaomi MI 10T / 10T Pro', 'Xiaomi MI 10T Lite',
      'Xiaomi Poco F3', 'Xiaomi Poco X3 GT', 'Xiaomi Poco X3/X3 NFC/X3 Pro',
      'Xiaomi Redmi Note 10 Pro/ Pro Max', 'Xiaomi Redmi Note 10/ 10S / Poco M5s',
      'Xiaomi Redmi Note 10 5G / Poco M3 Pro', 'Xiaomi Poco M3',
      'Xiaomi Redmi 10 5G', 'Xiaomi Redmi 10', 'Xiaomi Redmi 10C',
      'Xiaomi Redmi 9c / Redmi 10A', 'Xiaomi Redmi Note 9 Pro / 9S', 'Xiaomi Redmi Note 9',
      'Xiaomi Redmi 9T', 'Xiaomi Redmi 9A', 'Xiaomi Redmi 9',
      'Xiaomi Redmi A1 / Redmi A2',
      'Xiaomi Redmi Note 8 Pro', 'Xiaomi Redmi Note 8'
    ],
    Motorola: [
      'Motorola Edge 70 5G', 'Motorola G86 Power 5G', 'Motorola G56 5G', 'Motorola G06',
      'Motorola Edge 60 Pro 5G', 'Motorola Edge 60 fusion / Edge 60',
      'Motorola G85 5G', 'Motorola G55 5G', 'Motorola G35 5G', 'Motorola G15', 'Motorola G05 / E15',
      'Motorola Edge 50 Pro', 'Motorola Edge 50 Fusion', 'Motorola Edge 50 5G',
      'Motorola Edge 40', 'Motorola Edge 40 neo',
      'Motorola G84 5G', 'Motorola G54 5G', 'Motorola G53 5G', 'Motorola G52 / G82',
      'Motorola G34 5G', 'Motorola G04/G24/E14/G04s', 'Motorola G24 power', 'Motorola G14', 'Motorola G13', 'Motorola E13',
      'Motorola Edge 30 Pro', 'Motorola Edge 30 fusion', 'Motorola Edge 30 neo',
      'Motorola E22 / E22i', 'Motorola G200',
      'Motorola G71 5G', 'Motorola G60s', 'Motorola G60', 'Motorola G51 5G', 'Motorola G50 5G',
      'Motorola G31', 'Motorola G22', 'Motorola G20/G30', 'Motorola E32', 'Motorola E30/E40', 'Motorola E20',
      'Motorola edge 20 lite', 'Motorola G100',
      'Motorola E7 Power/E7i Power', 'Motorola E7',
      'Motorola G9 Plus', 'Motorola G9 Power', 'Motorola G9 / G9 Play',
      'Motorola G8 Power', 'Motorola G8 Plus', 'Motorola G8 Power Lite',
      'Motorola One Fusion', 'Motorola One Hyper 6.5\'\'', 'Motorola One Action', 'Motorola One Power',
      'Motorola G7 Power', 'Motorola G7 Play', 'Motorola E6S/E6i', 'Motorola E6 Plus', 'Motorola E6 Play',
      'Motorola G6 Plus', 'Motorola G6', 'Motorola E5/G6 Play', 'Motorola E4 Plus', 'Motorola E4'
    ],
    Huawei: [
      'Huawei Nova 11i', 'Huawei Nova 10', 'Huawei Nova Y90', 'Huawei Nova Y70',
      'Huawei Nova 9 SE', 'Huawei nova 9', 'Huawei P50 Pro', 'Huawei P50',
      'Huawei Nova 8i', 'Huawei Nova Y60',
      'Huawei Mate 40 Pro', 'Huawei P40 Pro', 'Huawei P40', 'Huawei P40 Lite',
      'Huawei Nova 7 SE', 'Huawei Y9A', 'Huawei Y7A', 'Huawei Y8P', 'Huawei Y7P', 'Huawei Y6P', 'Huawei Y5P',
      'Huawei Y8s', 'Huawei Y9S',
      'Huawei Mate 30 Pro', 'Huawei Nova 5T',
      'Huawei P30 Pro', 'Huawei P30', 'Huawei P30 Lite',
      'Huawei Y9 Prime 2019', 'Huawei Y9 2019', 'Huawei Y7 2019', 'Huawei Y6 2019', 'Huawei P Smart 2019',
      'Huawei Mate 20 Pro', 'Huawei Mate 20', 'Huawei Mate 20 Lite',
      'Huawei P20 Pro', 'Huawei P20', 'Huawei P20 Lite',
      'Huawei Y9 2018', 'Huawei Y5 2018/Y5 Lite 2018',
      'Huawei Mate 10 Pro', 'Huawei Mate 10 Lite',
      'Huawei P10 Plus', 'Huawei P10', 'Huawei P10 Lite',
      'Huawei Y7 Prime/Y7 2017'
    ],
    Honor: [
      'Honor X5C / X5C Plus', 'Honor Magic 8 Lite 5G', 'Honor X5B / X5B plus',
      'Honor 400 Smart 5G / X7D', 'Honor 400 Pro 5G', 'Honor X9C Smart', 'Honor 400 5G', 'Honor 400 Lite 5G',
      'Honor X8C', 'Honor Magic 7 Lite 5G / X9c', 'Honor X7c / 200 smart / X6B 5G',
      'Honor 200 5G', 'Honor 200 Lite 5G',
      'Honor X6A / X6A plus', 'Honor Magic 6 Lite 5G', 'Honor X8B', 'Honor X7B / 90 smart',
      'Honor 90 lite', 'Honor 90 5G', 'Honor X8A 4G',
      'Honor X6 / X6s / X8A 5G / X8 5G', 'Honor 70 5G',
      'Honor X7A', 'Honor Magic 5 Lite 5G', 'Honor X8 4G', 'Honor 50 5G', 'Honor X7'
    ],
    Vivo: [
      'Vivo V60 Lite 5G', 'Vivo V50 5G', 'Vivo V50 Lite 5G',
      'Vivo Y39 5G', 'Vivo Y38 5G', 'Vivo V40 SE',
      'Vivo Y04 / Y29s 5G', 'Vivo Y03 / Y18 / Y28s',
      'Vivo V30', 'Vivo V30 Lite', 'Vivo Y19s', 'Vivo Y17s',
      'Vivo V29 5G', 'Vivo Y36 5G / Y27 5G', 'Vivo Y27 4G',
      'Vivo V25 Pro', 'Vivo V25 5G', 'Vivo Y35', 'Vivo Y22s', 'Vivo Y16', 'Vivo Y02s',
      'Vivo V21 5G', 'Vivo Y55 5G', 'Vivo Y51 / Y53s', 'Vivo Y21s',
      'Vivo Y20/Y11s/Y20s', 'Vivo Y01 / Y15s', 'Vivo V20'
    ],
    OPPO: [
      'Oppo Reno 14F', 'Oppo Reno 13F', 'Oppo Reno 12F',
      'Oppo A80', 'Oppo A40', 'Oppo Reno 11F', 'Oppo A79 5G', 'Oppo A78 5G',
      'Oppo A58 4G', 'Oppo A38', 'Oppo Reno 10 5G', 'Oppo Find X5 Pro',
      'Oppo A57/A77', 'Oppo A17',
      'Oppo Reno 7 5G', 'Oppo Reno 7 4G', 'Oppo Reno 6 5g 6.43\'\'', 'Oppo Reno 6 Lite',
      'Oppo A16 6.52\'\'', 'Oppo A54', 'Oppo Reno 5 Lite', 'Oppo A15', 'Oppo A5 / A5 5G'
    ]
  };

  /* ══════════════════════════════════════════════════════════════
     PRODUCT_HANDLES — mapea cada marca al handle de su producto
     en Shopify. Samsung está dividido en 3 productos (A/J/S).
     ══════════════════════════════════════════════════════════════ */
  const PRODUCT_HANDLES = {
    Apple:      'carcasa-personalizada-iphone',
    'Samsung-A': 'case-personalizada-galaxy-a',
    'Samsung-J': 'case-personalizada-galaxy-j',
    'Samsung-S': 'case-personalizada-galaxy-s',
    Xiaomi:     'case-personalizada-xiaomi',
    Motorola:   'case-personalizada-motorola',
    Huawei:     'case-personalizada-huawei',
    Honor:      'case-personalizada-oppo-copia',
    Vivo:       'case-personalizada-vivo',
    OPPO:       'case-personalizada-honor'
  };

  /** Devuelve el handle del producto para una marca + modelo */
  function getProductHandle(brand, modelName) {
    if (brand === 'Samsung') {
      var name = (modelName || '').toLowerCase();
      if (/galaxy\s+s\d/.test(name)) return PRODUCT_HANDLES['Samsung-S'];
      if (/galaxy\s+j/.test(name))   return PRODUCT_HANDLES['Samsung-J'];
      return PRODUCT_HANDLES['Samsung-A'];
    }
    return PRODUCT_HANDLES[brand] || '';
  }

  /** Cache de producto: handle → {variants: [...]} */
  var _productCache = {};

  /** Busca el variant_id correcto para un modelo en su producto Shopify */
  function fetchVariantForModel(brand, modelName) {
    var handle = getProductHandle(brand, modelName);
    if (!handle) return Promise.resolve(null);

    if (_productCache[handle]) {
      return Promise.resolve(_findVariant(_productCache[handle], modelName));
    }

    return fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _productCache[handle] = data.product;
        return _findVariant(data.product, modelName);
      })
      .catch(function () { return null; });
  }

  /** Encuentra la variante cuyo option1 coincide con modelName.
   *  Estrategia de búsqueda (en orden):
   *  1. Match exacto normalizado
   *  2. Quitar prefijo de marca (ej: "Oppo Reno 14F" → "Reno 14F")
   *  3. Para compuestos "A57/A77" → buscar primera parte "A57"
   *  4. Fallback: primera variante disponible
   */
  function _findVariant(product, modelName) {
    if (!product || !product.variants) return null;
    var variants = product.variants;
    var target = normalizeText(modelName);

    /* 1. Match exacto */
    for (var i = 0; i < variants.length; i++) {
      var opt = normalizeText(variants[i].option1 || variants[i].title || '');
      if (opt === target) return variants[i];
    }

    /* 2. Quitar prefijo de marca del catálogo */
    var brandPrefixes = ['oppo ', 'xiaomi ', 'motorola ', 'huawei ', 'honor ',
      'vivo ', 'samsung ', 'galaxy ', 'iphone '];
    var stripped = target;
    for (var p = 0; p < brandPrefixes.length; p++) {
      if (stripped.startsWith(brandPrefixes[p])) {
        stripped = stripped.slice(brandPrefixes[p].length);
        break;
      }
    }
    if (stripped !== target) {
      for (var i = 0; i < variants.length; i++) {
        var opt = normalizeText(variants[i].option1 || variants[i].title || '');
        if (opt === stripped) return variants[i];
      }
    }

    /* 3. Compuestos: "a57/a77" → intentar "a57" */
    if (stripped.includes('/')) {
      var firstPart = stripped.split('/')[0].trim();
      for (var i = 0; i < variants.length; i++) {
        var opt = normalizeText(variants[i].option1 || variants[i].title || '');
        if (opt === firstPart) return variants[i];
      }
    }

    /* 4. Fallback: primera variante */
    return variants[0] || null;
  }

  function inferBrand(modelName) {
    const normalized = normalizeText(modelName);

    for (const rule of BRAND_RULES) {
      if (rule.patterns.some((pattern) => normalized.includes(pattern))) {
        return rule.name;
      }
    }

    return 'Otros';
  }

  function slugifyDevicePart(value) {
    return normalizeText(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function createDeviceKey(brand, model) {
    return `${slugifyDevicePart(brand)}--${slugifyDevicePart(model)}`;
  }

  function init(root) {
    if (!root || root.dataset.ccInitialized === 'true') return;
    root.dataset.ccInitialized = 'true';

    const form = qs(root, '.cc-customizer__form');
    const shell = qs(root, '[data-cc-shell]');

    const brandSelect = qs(root, '[data-cc-brand-select]');
    const brandToggle = qs(root, '[data-cc-brand-toggle]');
    const brandValue = qs(root, '[data-cc-brand-value]');
    const brandList = qs(root, '[data-cc-brand-list]');

    const search = qs(root, '[data-cc-model-search]');
    const list = qs(root, '[data-cc-model-list]');
    const empty = qs(root, '[data-cc-model-empty]');
    const toggle = qs(root, '[data-cc-combobox-toggle]');
    const combobox = qs(root, '[data-cc-combobox]');
    let options = qsa(root, '[data-cc-model-option]');

    const variantInput = qs(root, '[data-cc-variant-id]');
    const fileInput = qs(root, '[data-cc-file]');
    const photo = qs(root, '[data-cc-photo]');
    const placeholder = qs(root, '[data-cc-placeholder]');
    const placeholderBg = qs(root, '[data-cc-placeholder-bg]');
    const caseSvg = qs(root, '[data-cc-case]');
    const dragSurface = qs(root, '[data-cc-drag-surface]');
    const maskBody = qs(root, '[data-cc-mask-body]');
    const caseBase = qs(root, '[data-cc-case-base]');
    const caseShadow = qs(root, '[data-cc-case-shadow]');
    const caseOutline = qs(root, '[data-cc-case-outline]');
    const caseHighlight = qs(root, '[data-cc-case-highlight]');
    const holeMask = qs(root, '[data-cc-hole-mask]');
    const holeRings = qs(root, '[data-cc-hole-rings]');
    const dragHint = qs(root, '[data-cc-drag-hint]');

    const priceNodes = qsa(root, '[data-cc-price], [data-cc-summary-price]');
    const comparePriceNodes = qsa(root, '[data-cc-compare-price], [data-cc-summary-compare-price]');
    const submit = qs(root, '[data-cc-submit]');
    const submitLabel = qs(root, '[data-cc-submit-label]');
    const addCartBtn = qs(root, '[data-cc-add-cart]');
    const cartFeedback = qs(root, '[data-cc-cart-feedback]');
    const mobileAction = qs(root, '[data-cc-mobile-action]');
    const mobileActionLabel = qs(root, '[data-cc-mobile-action-label]');
    const mobilePreviewImage = qs(root, '[data-cc-mobile-preview-image]');

    const uploadLabel = qs(root, '[data-cc-upload-label]');
    const uploadHelp = qs(root, '[data-cc-upload-help]');
    const uploadAction = qs(root, '[data-cc-upload-action]');
    const photoControls = qs(root, '[data-cc-photo-controls]');
    const review = qs(root, '[data-cc-review]');
    const success = qs(root, '[data-cc-success]');
    const zoom = qs(root, '[data-cc-zoom]');
    const modelError = qs(root, '[data-cc-model-error]');
    const photoError = qs(root, '[data-cc-photo-error]');
    const photoWarning = qs(root, '[data-cc-photo-warning]');

    const zoomProperty = qs(root, '[data-cc-property-zoom]');
    const xProperty = qs(root, '[data-cc-property-x]');
    const yProperty = qs(root, '[data-cc-property-y]');
    const brandProperty = qs(root, '[data-cc-property-brand]');
    const deviceKeyProperty = qs(root, '[data-cc-property-device-key]');
    const visibleModelProperty = qs(root, '[data-cc-property-visible-model]');

    const selectedModelBox = qs(root, '[data-cc-selected-model]');
    const selectedBrandName = qs(root, '[data-cc-selected-brand-name]');
    const selectedModelName = qs(root, '[data-cc-selected-model-name]');
    const compactModelNames = qsa(root, '[data-cc-compact-model-name]');
    const summaryModels = qsa(root, '[data-cc-summary-model]');

    const changeModelButtons = qsa(root, '[data-cc-change-model]');
    const changePhotoButtons = qsa(root, '[data-cc-change-photo]');
    const zoomOut = qs(root, '[data-cc-zoom-out]');
    const zoomIn = qs(root, '[data-cc-zoom-in]');
    const resetPhoto = qs(root, '[data-cc-reset-photo]');

    const modelCard = qs(root, '[data-cc-model-card]');
    const personalizeCard = qs(root, '[data-cc-personalize]');
    const buyCard = qs(root, '[data-cc-buy]');
    const desktopCardToggles = qsa(root, '[data-cc-card-toggle]');

    if (
      !form ||
      !shell ||
      !caseSvg ||
      !fileInput ||
      !brandSelect ||
      !brandToggle ||
      !brandValue ||
      !brandList ||
      !search ||
      !list ||
      !combobox
    ) return;

    /* PERF: el barrido del DOM heredado (Uploadery) recorre document.body
       entero y fuerza layout. Solo debe correr si la plantilla declara
       explicitamente que el uploader antiguo sigue presente. */
    if (parseBool(root.dataset.hideLegacyUploader)) {
      watchLegacyUploader(root);
    }

    const url = new URL(window.location.href);
    const deepLinkedVariant = url.searchParams.get('variant');
    const deepLinkedBrand = url.searchParams.get('brand');
    const requireManualChoice = parseBool(root.dataset.requireManualChoice);
    const currentVariantId = String(root.dataset.currentVariantId || '');
    const currentModel = root.dataset.currentModel || '';
    const minShortSide = Number(root.dataset.minPhotoShortSide || 0);

    /* ── Construir botones de modelo desde MODEL_CATALOG ──────── */
    (function buildCatalogButtons() {
      /* Extraer precio/compare-price del primer botón Liquid (o del DOM) */
      const firstLiquidBtn = options[0];
      const defaultPriceFormatted =
        (firstLiquidBtn && firstLiquidBtn.dataset.priceFormatted) ||
        (priceNodes[0] && priceNodes[0].textContent.trim()) || '';
      const defaultComparePriceFormatted =
        (firstLiquidBtn && firstLiquidBtn.dataset.comparePriceFormatted) ||
        (comparePriceNodes[0] && comparePriceNodes[0].textContent.trim()) || '';
      const defaultPrice = (firstLiquidBtn && firstLiquidBtn.dataset.price) || '';
      const defaultComparePrice = (firstLiquidBtn && firstLiquidBtn.dataset.comparePrice) || '';

      /* Limpiar los botones Liquid existentes (se recrean desde catálogo) */
      options.forEach(function (btn) { btn.remove(); });

      var phoneIcon =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<rect x="6.5" y="2.5" width="11" height="19" rx="2.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
          '<path d="M10 5h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg>';

      /* PERF: se arma todo en memoria y se inserta una sola vez.
         Antes eran ~430 appendChild directos al DOM vivo. */
      var fragment = document.createDocumentFragment();

      Object.keys(MODEL_CATALOG).forEach(function (brand) {
        MODEL_CATALOG[brand].forEach(function (modelName) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'cc-model-option';
          button.setAttribute('role', 'option');
          button.dataset.ccModelOption = '';
          button.dataset.variantId = currentVariantId;
          button.dataset.modelName = modelName;
          button.dataset.price = defaultPrice;
          button.dataset.priceFormatted = defaultPriceFormatted;
          button.dataset.comparePrice = defaultComparePrice;
          button.dataset.comparePriceFormatted = defaultComparePriceFormatted;
          button.dataset.available = 'true';
          button.dataset.brand = brand;
          button.dataset.deviceKey = createDeviceKey(brand, modelName);

          /* Fuera del filtro de marca activa desde el inicio: evita un
             recalculo de estilo de toda la lista en el primer filtrado. */
          button.hidden = true;

          var iconSpan = document.createElement('span');
          iconSpan.className = 'cc-model-option__icon';
          iconSpan.innerHTML = phoneIcon;

          var nameSpan = document.createElement('span');
          nameSpan.className = 'cc-model-option__name';
          nameSpan.textContent = modelName;

          button.appendChild(iconSpan);
          button.appendChild(nameSpan);
          fragment.appendChild(button);
        });
      });

      list.appendChild(fragment);

      /* Re-referenciar los botones recién creados */
      options = qsa(root, '[data-cc-model-option]');
    })();

    /* ── Prefetch: cargar el producto actual en cache ── */
    (function prefetchCurrentProduct() {
      var path = window.location.pathname;
      var match = path.match(/\/products\/([^/?#]+)/);
      if (match) {
        var currentHandle = match[1];
        fetch('/products/' + currentHandle + '.json')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.product) {
              _productCache[currentHandle] = data.product;
            }
          })
          .catch(function () {});
      }
    })();

    const brands = Object.keys(MODEL_CATALOG).sort(function (a, b) {
      var aIndex = BRAND_PRIORITY.indexOf(a);
      var bIndex = BRAND_PRIORITY.indexOf(b);
      var safeA = aIndex === -1 ? 999 : aIndex;
      var safeB = bIndex === -1 ? 999 : bIndex;
      return safeA - safeB || a.localeCompare(b);
    });

    const currentOption = currentModel
      ? options.find(
          (option) => normalizeText(option.dataset.modelName) === normalizeText(currentModel)
        )
      : null;

    const state = {
      step: 1,

      brandSelected: false,
      brandName: '',

      modelSelected: false,
      modelName: '',
      deviceKey: '',
      variantId: '',

      priceFormatted: priceNodes[0]?.textContent?.trim() || '',
      comparePriceFormatted: comparePriceNodes[0]?.textContent?.trim() || '',

      hasPhoto: false,
      photoUrl: '',
      photoDataUrl: '',
      originalFile: null,
      mobilePreviewUrl: '',
      imageNaturalWidth: 0,
      imageNaturalHeight: 0,
      baseScale: 1,
      zoom: 1,
      dx: 0,
      dy: 0,

      dragging: false,
      pointerId: null,
      pointerStartX: 0,
      pointerStartY: 0,
      startDx: 0,
      startDy: 0,

      editorLocked: false,
      designConfirmed: false,

      geometry: getGeometry(root, currentModel)
    };

    function buildBrandList() {
      brandList.replaceChildren();

      brands.forEach((brand) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cc-brand-option';
        button.dataset.ccBrandOption = '';
        button.dataset.brandName = brand;
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', 'false');

        const icon = document.createElement('span');
        icon.className = 'cc-brand-option__icon';
        icon.textContent = brand.slice(0, 2);

        const name = document.createElement('span');
        name.className = 'cc-brand-option__name';
        name.textContent = brand;

        const check = document.createElement('span');
        check.className = 'cc-brand-option__check';
        check.textContent = '✓';

        button.append(icon, name, check);

        button.addEventListener('click', () => {
          selectBrand(brand, {
            resetModel: true,
            openModels: true
          });
        });

        brandList.appendChild(button);
      });
    }

    function setBodyGeometry(geometry) {
      const b = geometry.body;

      [maskBody, caseBase, caseShadow, placeholderBg, caseOutline].forEach((el) => {
        if (!el) return;
        el.setAttribute('x', b.x);
        el.setAttribute('y', b.y);
        el.setAttribute('width', b.w);
        el.setAttribute('height', b.h);
        el.setAttribute('rx', b.rx);
      });

      if (dragSurface) {
        dragSurface.setAttribute('x', b.x);
        dragSurface.setAttribute('y', b.y);
        dragSurface.setAttribute('width', b.w);
        dragSurface.setAttribute('height', b.h);
        dragSurface.setAttribute('rx', b.rx);
      }

      if (caseHighlight) {
        caseHighlight.setAttribute('x', b.x + 5);
        caseHighlight.setAttribute('y', b.y + 5);
        caseHighlight.setAttribute('width', b.w - 10);
        caseHighlight.setAttribute('height', b.h - 10);
        caseHighlight.setAttribute('rx', Math.max(8, b.rx - 5));
      }

      if (placeholder) {
        placeholder.setAttribute(
          'transform',
          `translate(${b.x - 28} ${b.y - 28})`
        );
      }
    }

    function renderHoles(holes) {
      if (!holeMask || !holeRings) return;

      holeMask.replaceChildren();
      holeRings.replaceChildren();

      holes.forEach((hole) => {
        if (hole.type === 'circle') {
          holeMask.appendChild(createSvg('circle', {
            cx: hole.cx,
            cy: hole.cy,
            r: hole.r,
            fill: 'black'
          }));

          holeRings.appendChild(createSvg('circle', {
            cx: hole.cx,
            cy: hole.cy,
            r: hole.r + 3,
            fill: 'none',
            stroke: 'rgba(24,24,24,.28)',
            'stroke-width': 5,
            'paint-order': 'stroke fill markers'
          }));

          holeRings.appendChild(createSvg('circle', {
            cx: hole.cx,
            cy: hole.cy,
            r: hole.r,
            fill: 'none',
            stroke: 'rgba(255,255,255,.45)',
            'stroke-width': 1.2,
            'paint-order': 'stroke fill markers'
          }));

          return;
        }

        holeMask.appendChild(createSvg('rect', {
          x: hole.x,
          y: hole.y,
          width: hole.w,
          height: hole.h,
          rx: hole.rx,
          fill: 'black'
        }));

        holeRings.appendChild(createSvg('rect', {
          x: hole.x - 3,
          y: hole.y - 3,
          width: hole.w + 6,
          height: hole.h + 6,
          rx: hole.rx + 3,
          fill: 'none',
          stroke: 'rgba(24,24,24,.28)',
          'stroke-width': 5,
          'paint-order': 'stroke fill markers'
        }));

        holeRings.appendChild(createSvg('rect', {
          x: hole.x,
          y: hole.y,
          width: hole.w,
          height: hole.h,
          rx: hole.rx,
          fill: 'none',
          stroke: 'rgba(255,255,255,.45)',
          'stroke-width': 1.2,
          'paint-order': 'stroke fill markers'
        }));
      });
    }

    function renderGeometry() {
      setBodyGeometry(state.geometry);
      renderHoles(state.geometry.holes);
      computeBaseScale();
      clampPhotoPosition();
      renderPhoto();
    }

    function computeBaseScale() {
      const b = state.geometry.body;

      if (!state.imageNaturalWidth || !state.imageNaturalHeight) {
        state.baseScale = 1;
        return;
      }

      state.baseScale = Math.min(
        b.w / state.imageNaturalWidth,
        b.h / state.imageNaturalHeight
      );
    }

    function getScaledPhotoDimensions() {
      return {
        width: state.imageNaturalWidth * state.baseScale * state.zoom,
        height: state.imageNaturalHeight * state.baseScale * state.zoom
      };
    }

    function clampPhotoPosition() {
      if (!state.hasPhoto) {
        state.dx = 0;
        state.dy = 0;
      }
    }

    function syncMobilePreviewImage() {
      if (!mobilePreviewImage || !caseSvg || !state.hasPhoto || !state.photoDataUrl) return;

      try {
        const clone = caseSvg.cloneNode(true);
        clone.classList.remove('is-editable', 'is-dragging', 'is-locked');

        qsa(clone, '[data-cc-drag-surface]').forEach((node) => node.remove());

        const clonePhoto = qs(clone, '[data-cc-photo]');
        if (clonePhoto) {
          clonePhoto.setAttribute('href', state.photoDataUrl);
          clonePhoto.setAttributeNS(
            'http://www.w3.org/1999/xlink',
            'href',
            state.photoDataUrl
          );
        }

        if (!clone.getAttribute('xmlns')) {
          clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        }

        if (!clone.getAttribute('xmlns:xlink')) {
          clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        }

        const svgMarkup = new XMLSerializer().serializeToString(clone);
        const svgBlob = new Blob([svgMarkup], { type: 'image/svg+xml;charset=utf-8' });

        if (state.mobilePreviewUrl) {
          URL.revokeObjectURL(state.mobilePreviewUrl);
        }

        state.mobilePreviewUrl = URL.createObjectURL(svgBlob);
        mobilePreviewImage.src = state.mobilePreviewUrl;
        mobilePreviewImage.alt = state.modelSelected
          ? `Resumen del diseño para ${state.modelName}`
          : 'Resumen de tu diseño personalizado';
      } catch (_) {
        // El resumen nunca debe bloquear la compra.
      }
    }

    /* PERF: coalescer los repintados del preview en un unico frame.
       pointermove puede disparar hasta 120 eventos/s; sin esto cada uno
       repinta el SVG completo. */
    let renderRaf = null;

    function scheduleRenderPhoto() {
      if (renderRaf !== null) return;
      renderRaf = requestAnimationFrame(() => {
        renderRaf = null;
        renderPhoto();
      });
    }

    function renderPhoto() {
      if (!photo) return;

      if (!state.hasPhoto) {
        photo.setAttribute('opacity', '0');
        return;
      }

      const b = state.geometry.body;
      const scaled = getScaledPhotoDimensions();

      const x = b.x + (b.w - scaled.width) / 2 + state.dx;
      const y = b.y + (b.h - scaled.height) / 2 + state.dy;

      photo.setAttribute('x', x);
      photo.setAttribute('y', y);
      photo.setAttribute('width', scaled.width);
      photo.setAttribute('height', scaled.height);
      photo.setAttribute('opacity', '1');

      if (zoomProperty) zoomProperty.value = state.zoom.toFixed(3);
      if (xProperty) xProperty.value = state.dx.toFixed(2);
      if (yProperty) yProperty.value = state.dy.toFixed(2);
    }

    function setZoom(nextZoom) {
      if (state.editorLocked) return;

      state.zoom = Math.max(
        0.15,
        Math.min(6, Number(nextZoom) || 1)
      );

      if (zoom) zoom.value = String(state.zoom);

      scheduleRenderPhoto();
    }

    function resetPhotoPosition() {
      if (!state.hasPhoto || state.editorLocked) return;

      state.zoom = 1;
      state.dx = 0;
      state.dy = 0;

      if (zoom) zoom.value = '1';

      renderPhoto();
    }

    function setEditorLocked(locked) {
      state.editorLocked = Boolean(locked);

      caseSvg.classList.toggle('is-locked', state.editorLocked);
      caseSvg.classList.toggle(
        'is-editable',
        state.hasPhoto && !state.editorLocked
      );

      if (photoControls) {
        photoControls.classList.toggle('is-locked', state.editorLocked);
      }

      if (dragHint) {
        dragHint.hidden = state.editorLocked || !state.hasPhoto;
        dragHint.classList.toggle('is-locked', state.editorLocked);
      }

      if (zoom) zoom.disabled = state.editorLocked || !state.hasPhoto;
      if (zoomOut) zoomOut.disabled = state.editorLocked || !state.hasPhoto;
      if (zoomIn) zoomIn.disabled = state.editorLocked || !state.hasPhoto;
      if (resetPhoto) resetPhoto.disabled = state.editorLocked || !state.hasPhoto;
    }

    function setModelControlEnabled(enabled) {
      combobox.classList.toggle('is-disabled', !enabled);

      search.disabled = !enabled;
      toggle.disabled = !enabled;

      search.placeholder = enabled
        ? 'Busca tu modelo...'
        : 'Selecciona primero una marca';

      if (!enabled) {
        search.value = '';
        closeModelList();
      }
    }

    function updateBrandUi() {
      brandSelect.classList.toggle(
        'has-value',
        state.brandSelected
      );

      brandValue.textContent = state.brandSelected
        ? state.brandName
        : 'Selecciona una marca';

      qsa(brandList, '[data-cc-brand-option]').forEach((button) => {
        button.setAttribute(
          'aria-selected',
          String(button.dataset.brandName === state.brandName)
        );
      });

      if (brandProperty) {
        brandProperty.value = state.brandSelected
          ? state.brandName
          : '';
      }
    }

    function updateDeviceProperties() {
      if (deviceKeyProperty) {
        deviceKeyProperty.value = state.deviceKey || '';
      }

      if (visibleModelProperty) {
        visibleModelProperty.value =
          state.brandSelected && state.modelSelected
            ? state.brandName + ': ' + state.modelName
            : '';
      }
    }

    function resetModelSelection({
      preservePhoto = true
    } = {}) {
      state.modelSelected = false;
      state.modelName = '';
      state.deviceKey = '';
      state.variantId = '';
      state.designConfirmed = false;
      root.classList.remove('cc-has-model');

      if (!preservePhoto) {
        state.hasPhoto = false;
      }

      search.value = '';

      updateModelText();
      updateDeviceProperties();

      options.forEach((item) => {
        item.setAttribute('aria-selected', 'false');
      });

      state.geometry = getGeometry(root, '');
      renderGeometry();
      setEditorLocked(false);
      updateUi();
    }

    function selectBrand(
      brand,
      {
        resetModel = true,
        openModels = false
      } = {}
    ) {
      if (!brand) return;

      const brandChanged = state.brandName !== brand;

      state.brandSelected = true;
      state.brandName = brand;

      updateBrandUi();
      setModelControlEnabled(true);
      closeBrandList();

      if (resetModel && brandChanged) {
        resetModelSelection({
          preservePhoto: true
        });
      }

      filterModels();

      if (modelError) {
        modelError.hidden = true;
      }

      updateUi();

      if (openModels) {
        requestAnimationFrame(() => {
          search.focus({ preventScroll: true });
          openModelList();
        });
      }
    }

    function openBrandList() {
      brandList.hidden = false;
      brandSelect.classList.add('is-open');
      brandToggle.setAttribute('aria-expanded', 'true');
    }

    function closeBrandList() {
      brandList.hidden = true;
      brandSelect.classList.remove('is-open');
      brandToggle.setAttribute('aria-expanded', 'false');
    }

    function syncDesktopAccordion() {
      if (!modelCard || !personalizeCard || !buyCard) return;

      const isDesktop = window.innerWidth > 1023;

      if (!isDesktop) {
        [modelCard, personalizeCard, buyCard].forEach((card) => {
          card.classList.remove(
            'is-open',
            'is-collapsed',
            'is-locked-step'
          );
        });

        desktopCardToggles.forEach((item) => {
          item.setAttribute('aria-expanded', 'true');
        });

        return;
      }

      const cards = [
        {
          step: 1,
          card: modelCard,
          enabled: true
        },
        {
          step: 2,
          card: personalizeCard,
          enabled: state.modelSelected
        },
        {
          step: 3,
          card: buyCard,
          enabled: state.designConfirmed
        }
      ];

      cards.forEach(({ step, card, enabled }) => {
        const open = state.step === step;

        card.classList.toggle('is-open', open);
        card.classList.toggle('is-collapsed', !open);
        card.classList.toggle('is-locked-step', !enabled);

        const cardToggle = qs(card, '[data-cc-card-toggle]');

        if (cardToggle) {
          cardToggle.setAttribute(
            'aria-expanded',
            String(open)
          );

          cardToggle.setAttribute(
            'aria-disabled',
            String(!enabled)
          );
        }
      });
    }

    function openDesktopCard(step) {
      if (window.innerWidth <= 1023) return;

      if (step === 1) {
        state.designConfirmed = false;
        setEditorLocked(false);
        setStep(1, { scroll: false });
        return;
      }

      if (step === 2) {
        if (!state.modelSelected) return;

        state.designConfirmed = false;
        setEditorLocked(false);
        setStep(2, { scroll: false });
        return;
      }

      if (step === 3) {
        if (!state.designConfirmed) return;

        setStep(3, { scroll: false });
      }
    }

    function updatePrice(priceFormatted, comparePriceFormatted = '') {
      if (!priceFormatted) return;

      state.priceFormatted = priceFormatted;
      state.comparePriceFormatted = comparePriceFormatted || '';

      priceNodes.forEach((node) => {
        node.textContent = priceFormatted;
      });

      comparePriceNodes.forEach((node) => {
        if (comparePriceFormatted && comparePriceFormatted !== priceFormatted) {
          node.textContent = comparePriceFormatted;
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });

      /* V3.0: el botón dice solo "Comprar", sin precio */
      if (submitLabel) {
        submitLabel.textContent = 'Comprar';
      }
    }

    function updateModelText() {
      if (selectedBrandName) {
        selectedBrandName.textContent = state.brandSelected
          ? state.brandName
          : '';
      }

      if (selectedModelName) {
        selectedModelName.textContent = state.modelName;
      }

      compactModelNames.forEach((node) => {
        node.textContent = state.modelName;
      });

      summaryModels.forEach((node) => {
        node.textContent = state.modelName;
      });

      if (selectedModelBox) {
        selectedModelBox.hidden = !state.modelSelected;
      }
    }

    function closeModelList() {
      list.hidden = true;
      search.setAttribute('aria-expanded', 'false');
    }

    function openModelList() {
      if (!state.brandSelected) {
        openBrandList();
        return;
      }

      list.hidden = false;
      search.setAttribute('aria-expanded', 'true');
      filterModels();
    }

    function filterModels() {
      const query = normalizeText(search.value);
      let visible = 0;

      options.forEach((option) => {
        const sameBrand =
          state.brandSelected &&
          option.dataset.brand === state.brandName;

        const matchesQuery =
          !query ||
          normalizeText(option.dataset.modelName).includes(query);

        const show = sameBrand && matchesQuery;

        /* PERF: escribir .hidden con el mismo valor igual invalida
           estilo. Con ~430 opciones eso es un recalculo por tecla. */
        if (option.hidden === show) {
          option.hidden = !show;
        }

        if (show) {
          visible += 1;
        }
      });

      if (empty) {
        empty.hidden = visible !== 0;
      }
    }

    function setModelFromOption(
      option,
      {
        advance = true
      } = {}
    ) {
      if (!option || option.disabled) return;

      const optionBrand =
        option.dataset.brand ||
        inferBrand(option.dataset.modelName);

      if (
        !state.brandSelected ||
        state.brandName !== optionBrand
      ) {
        selectBrand(optionBrand, {
          resetModel: false,
          openModels: false
        });
      }

      state.modelSelected = true;
      state.designConfirmed = false;
      root.classList.add('cc-has-model');

      state.modelName = option.dataset.modelName || '';
      state.variantId = option.dataset.variantId || '';
      state.deviceKey =
        option.dataset.deviceKey ||
        createDeviceKey(state.brandName, state.modelName);

      state.geometry = getGeometry(root, state.modelName);

      if (variantInput) {
        variantInput.value = state.variantId;
      }

      search.value = state.modelName;

      updatePrice(
        option.dataset.priceFormatted || state.priceFormatted,
        option.dataset.comparePriceFormatted || state.comparePriceFormatted
      );

      updateModelText();
      updateDeviceProperties();
      renderGeometry();

      if (modelError) {
        modelError.hidden = true;
      }

      closeModelList();
      closeBrandList();

      /* ── Fetch del variant_id correcto desde el producto Shopify ── */
      fetchVariantForModel(state.brandName, state.modelName)
        .then(function (variant) {
          if (variant && variant.id) {
            state.variantId = String(variant.id);
            if (variantInput) variantInput.value = state.variantId;

            /* Actualizar precio desde la variante del producto correcto */
            if (variant.price) {
              var priceStr = String(variant.price);
              /* Shopify devuelve precio como "9990.00" o "9990" para CLP */
              var priceNum = Math.round(parseFloat(priceStr));
              var formatted = '$' + priceNum.toLocaleString('es-CL');
              var compareFormatted = '';
              if (variant.compare_at_price && parseFloat(variant.compare_at_price) > priceNum) {
                compareFormatted = '$' + Math.round(parseFloat(variant.compare_at_price)).toLocaleString('es-CL');
              }
              updatePrice(formatted, compareFormatted);
            }
          }

          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', state.variantId);
          window.history.replaceState({}, '', nextUrl);
        });

      options.forEach((item) => {
        item.setAttribute(
          'aria-selected',
          String(normalizeText(item.dataset.modelName) === normalizeText(state.modelName))
        );
      });

      if (advance) {
        setStep(2, {
          scroll: window.innerWidth <= 1023
        });
      } else {
        syncDesktopAccordion();
        updateUi();
      }
    }

    function clearPhotoError() {
      if (photoError) {
        photoError.hidden = true;
      }
    }

    function setPhotoError() {
      if (photoError) {
        photoError.hidden = false;
      }
    }

    function updatePhotoWarning() {
      if (!photoWarning) return;

      if (
        minShortSide > 0 &&
        state.imageNaturalWidth &&
        state.imageNaturalHeight &&
        Math.min(
          state.imageNaturalWidth,
          state.imageNaturalHeight
        ) < minShortSide
      ) {
        photoWarning.hidden = false;
      } else {
        photoWarning.hidden = true;
      }
    }

    /* Lado mayor del preview. 1600px sobra para una carcasa en pantalla
       y baja el costo de re-muestreo ~85% frente a una foto de 12 MP. */
    const PREVIEW_MAX_SIDE = 1600;

    function setPhotoHref(href) {
      if (!photo || !href) return;
      photo.setAttribute('href', href);
      photo.setAttributeNS('http://www.w3.org/1999/xlink', 'href', href);
    }

    /* Fallback: solo si el canvas no esta disponible o la foto ya es
       pequena. Mantiene el comportamiento anterior. */
    function readAsDataUrl(file) {
      const reader = new FileReader();
      reader.onload = () => {
        state.photoDataUrl = typeof reader.result === 'string' ? reader.result : '';
        if (state.step === 3 && state.designConfirmed) {
          syncMobilePreviewImage();
        }
      };
      reader.readAsDataURL(file);
    }

    function setPhotoFile(file) {
      clearPhotoError();

      if (!file) return;

      if (!file.type.startsWith('image/')) {
        setPhotoError();
        return;
      }

      if (state.photoUrl) {
        URL.revokeObjectURL(state.photoUrl);
      }

      /* El archivo original se conserva intacto para la imagen de
         impresion; el preview usa una version reducida. */
      state.originalFile = file;
      state.photoUrl = '';
      state.photoDataUrl = '';

      const sourceUrl = URL.createObjectURL(file);
      const img = new Image();

      img.onload = () => {
        /* IMPORTANTE: se conservan las dimensiones ORIGINALES. Toda la
           matematica de baseScale y del recorte print-ready mapea
           coordenadas SVG a pixeles del archivo original. */
        state.imageNaturalWidth = img.naturalWidth || 0;
        state.imageNaturalHeight = img.naturalHeight || 0;

        /* PERF: una foto de 12 MP se re-muestrea en cada frame de
           arrastre. Se reduce una sola vez a PREVIEW_MAX_SIDE y el SVG
           trabaja con esa copia liviana. */
        const longestSide = Math.max(
          state.imageNaturalWidth,
          state.imageNaturalHeight
        );

        const scale = longestSide > PREVIEW_MAX_SIDE
          ? PREVIEW_MAX_SIDE / longestSide
          : 1;

        let previewCanvas = null;

        if (scale < 1) {
          try {
            previewCanvas = document.createElement('canvas');
            previewCanvas.width = Math.max(1, Math.round(state.imageNaturalWidth * scale));
            previewCanvas.height = Math.max(1, Math.round(state.imageNaturalHeight * scale));
            const pctx = previewCanvas.getContext('2d');
            pctx.drawImage(img, 0, 0, previewCanvas.width, previewCanvas.height);
          } catch (_) {
            previewCanvas = null;
          }
        }

        if (previewCanvas) {
          /* Data URL reducido: lo usa el mockup de 600px y el resumen
             movil. Antes se guardaba el original completo en base64
             (varios MB retenidos en memoria). */
          try {
            state.photoDataUrl = previewCanvas.toDataURL('image/jpeg', 0.85);
          } catch (_) {
            state.photoDataUrl = '';
          }

          if (previewCanvas.toBlob) {
            previewCanvas.toBlob((blob) => {
              if (!blob) return;
              if (state.photoUrl) URL.revokeObjectURL(state.photoUrl);
              state.photoUrl = URL.createObjectURL(blob);
              setPhotoHref(state.photoUrl);
            }, 'image/jpeg', 0.85);
          }

          /* Mientras el blob se genera, el data URL ya sirve de fuente. */
          state.photoUrl = state.photoUrl || state.photoDataUrl;
        } else {
          state.photoUrl = sourceUrl;
          readAsDataUrl(file);
        }

        state.hasPhoto = true;
        state.designConfirmed = false;

        state.zoom = 1;
        state.dx = 0;
        state.dy = 0;

        computeBaseScale();

        setPhotoHref(state.photoUrl);

        if (previewCanvas) {
          URL.revokeObjectURL(sourceUrl);
        }

        if (placeholder) {
          placeholder.hidden = true;
          placeholder.style.display = 'none';
        }

        if (photoControls) {
          photoControls.hidden = false;
        }

        root.classList.add('has-photo');

        if (uploadLabel) {
          uploadLabel.textContent = 'Foto cargada';
        }

        if (uploadHelp) {
          uploadHelp.textContent = 'Toca aqui para reemplazarla';
        }

        if (uploadAction) {
          uploadAction.textContent = 'Cambiar';
        }

        updatePhotoWarning();
        setZoom(1);
        setEditorLocked(false);
        updateUi();
      };

      img.onerror = () => {
        URL.revokeObjectURL(sourceUrl);
        state.hasPhoto = false;
        setPhotoError();
        updateUi();
      };

      img.src = sourceUrl;
    }

    function setStep(step, { scroll = false } = {}) {
      if (step === 2 && !state.modelSelected) {
        if (modelError) {
          modelError.hidden = false;
        }

        step = 1;
      }

      if (
        step === 3 &&
        (
          !state.modelSelected ||
          !state.hasPhoto ||
          !state.designConfirmed
        )
      ) {
        step = state.modelSelected
          ? 2
          : 1;
      }

      state.step = Math.max(
        1,
        Math.min(3, step)
      );

      shell.dataset.mobileStep =
        String(state.step);

      qsa(root, '[data-cc-step-target]').forEach((node) => {
        const target =
          Number(node.dataset.ccStepTarget);

        node.classList.toggle(
          'is-active',
          target === state.step
        );

        node.classList.toggle(
          'is-complete',
          target < state.step
        );

        if (target === state.step) {
          node.setAttribute(
            'aria-current',
            'step'
          );
        } else {
          node.removeAttribute(
            'aria-current'
          );
        }

        const dot = qs(
          node,
          '.cc-step__dot'
        );

        if (dot) {
          dot.textContent =
            target < state.step
              ? '✓'
              : String(target);
        }
      });

      qsa(root, '[data-cc-step-line]').forEach((line) => {
        const index =
          Number(line.dataset.ccStepLine);

        line.classList.toggle(
          'is-complete',
          state.step > index
        );
      });

      setEditorLocked(
        state.step === 3 &&
        state.designConfirmed
      );

      if (state.step === 3 && state.designConfirmed) {
        syncMobilePreviewImage();
      }

      if (success) {
        success.hidden = !(
          state.step === 3 &&
          state.designConfirmed
        );
      }

      syncDesktopAccordion();
      updateUi();

      if (
        scroll &&
        window.innerWidth <= 1023
      ) {
        const targetSelector =
          state.step === 1
            ? '[data-cc-model-card]'
            : state.step === 2
              ? '[data-cc-preview]'
              : '[data-cc-buy]';

        const target =
          qs(root, targetSelector);

        if (target) {
          requestAnimationFrame(() => {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          });
        }
      }
    }

    function updateUi() {
      const canConfirm =
        state.brandSelected &&
        state.modelSelected &&
        state.hasPhoto;

      const canBuy =
        canConfirm &&
        state.designConfirmed;

      if (submit) {
        submit.disabled = !canBuy;
      }

      if (addCartBtn) {
        addCartBtn.disabled = !canBuy;
      }

      if (review) {
        review.disabled = !canConfirm;
      }

      if (
        !mobileAction ||
        !mobileActionLabel
      ) return;

      mobileAction.classList.remove(
        'is-disabled'
      );

      if (state.step === 1) {
        if (!state.brandSelected) {
          mobileActionLabel.textContent =
            'Selecciona una marca';

          mobileAction.classList.add(
            'is-disabled'
          );

          return;
        }

        if (!state.modelSelected) {
          mobileActionLabel.textContent =
            'Selecciona tu modelo';

          mobileAction.classList.add(
            'is-disabled'
          );

          return;
        }

        mobileActionLabel.textContent =
          'Continuar';

        return;
      }

      if (state.step === 2) {
        mobileActionLabel.textContent =
          state.hasPhoto
            ? 'Confirmar diseño'
            : 'Subir mi foto';

        return;
      }

      mobileActionLabel.textContent = 'Comprar';

      mobileAction.classList.toggle(
        'is-disabled',
        !canBuy
      );
    }

    function changeModel() {
      state.designConfirmed = false;
      setEditorLocked(false);
      setStep(1, { scroll: true });

      requestAnimationFrame(() => {
        if (state.brandSelected) {
          search.focus({
            preventScroll: true
          });

          search.select();
          openModelList();
        } else {
          brandToggle.focus({
            preventScroll: true
          });

          openBrandList();
        }
      });
    }

    function changePhoto() {
      state.designConfirmed = false;
      setEditorLocked(false);

      if (!state.modelSelected) {
        setStep(1, { scroll: true });
        return;
      }

      setStep(2, { scroll: true });
      fileInput.click();
    }

    buildBrandList();
    setModelControlEnabled(false);
    updateBrandUi();
    updateModelText();
    updateDeviceProperties();

    brandToggle.addEventListener('click', () => {
      if (brandList.hidden) {
        closeModelList();
        openBrandList();
      } else {
        closeBrandList();
      }
    });

    if (search) {
      search.addEventListener('focus', () => {
        if (state.brandSelected) {
          openModelList();
        } else {
          search.blur();
          openBrandList();
        }
      });

      search.addEventListener('input', () => {
        if (!state.brandSelected) return;

        openModelList();
        filterModels();
      });

      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeModelList();
        }
      });
    }

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (!state.brandSelected) {
          openBrandList();
          return;
        }

        if (list.hidden) {
          openModelList();
          search.focus();
        } else {
          closeModelList();
        }
      });
    }

    options.forEach((option) => {
      option.addEventListener('click', () => {
        setModelFromOption(option);
      });
    });

    document.addEventListener('click', (event) => {
      if (
        brandSelect &&
        !brandSelect.contains(event.target)
      ) {
        closeBrandList();
      }

      if (
        combobox &&
        !combobox.contains(event.target)
      ) {
        closeModelList();
      }
    });

    fileInput.addEventListener('change', () => {
      setPhotoFile(
        fileInput.files?.[0]
      );
    });

    changeModelButtons.forEach((button) => {
      button.addEventListener(
        'click',
        changeModel
      );
    });

    changePhotoButtons.forEach((button) => {
      button.addEventListener(
        'click',
        changePhoto
      );
    });

    if (review) {
      review.addEventListener('click', () => {
        if (
          state.brandSelected &&
          state.modelSelected &&
          state.hasPhoto
        ) {
          state.designConfirmed = true;

          setStep(3, {
            scroll: true
          });
        }
      });
    }

    if (zoom) {
      zoom.addEventListener(
        'input',
        () => setZoom(zoom.value)
      );
    }

    zoomOut?.addEventListener(
      'click',
      () => setZoom(state.zoom - 0.15)
    );

    zoomIn?.addEventListener(
      'click',
      () => setZoom(state.zoom + 0.15)
    );

    resetPhoto?.addEventListener(
      'click',
      resetPhotoPosition
    );

    qsa(root, '[data-cc-step-target]').forEach((button) => {
      button.addEventListener('click', () => {
        const target =
          Number(button.dataset.ccStepTarget);

        if (target === 1) {
          return changeModel();
        }

        if (
          target === 2 &&
          state.modelSelected
        ) {
          return setStep(2, {
            scroll: true
          });
        }

        if (
          target === 3 &&
          state.designConfirmed
        ) {
          return setStep(3, {
            scroll: true
          });
        }
      });
    });

    desktopCardToggles.forEach((cardToggle) => {
      const activate = () => {
        const step =
          Number(cardToggle.dataset.ccCardToggle);

        openDesktopCard(step);
      };

      cardToggle.addEventListener(
        'click',
        activate
      );

      cardToggle.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            event.preventDefault();
            activate();
          }
        }
      );
    });

    window.addEventListener(
      'resize',
      syncDesktopAccordion,
      { passive: true }
    );

    if (mobileAction) {
      mobileAction.addEventListener('click', () => {
        if (state.step === 1) {
          if (!state.brandSelected) {
            openBrandList();
            return;
          }

          if (!state.modelSelected) {
            openModelList();
            search.focus();
            return;
          }

          setStep(2, {
            scroll: true
          });

          return;
        }

        if (state.step === 2) {
          if (!state.hasPhoto) {
            fileInput.click();
            return;
          }

          state.designConfirmed = true;

          setStep(3, {
            scroll: true
          });

          return;
        }

        if (
          state.step === 3 &&
          state.brandSelected &&
          state.modelSelected &&
          state.hasPhoto &&
          state.designConfirmed
        ) {
          form.requestSubmit();
        }
      });
    }

    /* ── helper: render SVG clone to canvas at given size ── */
    function svgToCanvas(svgEl, width) {
      return new Promise(function (resolve) {
        try {
          var clone = svgEl.cloneNode(true);
          clone.classList.remove('is-editable', 'is-dragging', 'is-locked');
          qsa(clone, '[data-cc-drag-surface]').forEach(function (n) { n.remove(); });

          var clonePhoto = qs(clone, '[data-cc-photo]');
          if (clonePhoto) {
            clonePhoto.setAttribute('href', state.photoDataUrl);
            clonePhoto.setAttributeNS('http://www.w3.org/1999/xlink', 'href', state.photoDataUrl);
          }

          if (!clone.getAttribute('xmlns')) clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          if (!clone.getAttribute('xmlns:xlink')) clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

          var markup = new XMLSerializer().serializeToString(clone);
          var blob = new Blob([markup], { type: 'image/svg+xml;charset=utf-8' });
          var url = URL.createObjectURL(blob);

          var img = new Image();
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = Math.round(width * (img.naturalHeight / img.naturalWidth));
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            URL.revokeObjectURL(url);
            resolve(canvas);
          };
          img.onerror = function () {
            URL.revokeObjectURL(url);
            resolve(null);
          };
          img.src = url;
        } catch (_) {
          resolve(null);
        }
      });
    }

    /* ── 1) Preview del mockup (600px, para visualizar rápido en el pedido) ── */
    function captureMockupPreview() {
      if (!caseSvg || !state.hasPhoto || !state.photoDataUrl) {
        return Promise.resolve(null);
      }
      return svgToCanvas(caseSvg, 600).then(function (canvas) {
        if (!canvas) return null;
        return canvas.toDataURL('image/jpeg', 0.75);
      });
    }

    /* ── 2) Imagen print-ready (foto recortada al área de impresión, alta res) ── */
    function capturePrintReady() {
      if (!state.hasPhoto || !state.originalFile) {
        return Promise.resolve(null);
      }

      return new Promise(function (resolve) {
        try {
          var b = state.geometry.body;
          var scaled = getScaledPhotoDimensions();

          /* Posición de la foto en coordenadas SVG */
          var photoX = b.x + (b.w - scaled.width) / 2 + state.dx;
          var photoY = b.y + (b.h - scaled.height) / 2 + state.dy;

          /* Cuánto del body cae dentro de la foto (crop region en SVG coords) */
          var cropX = Math.max(b.x, photoX);
          var cropY = Math.max(b.y, photoY);
          var cropR = Math.min(b.x + b.w, photoX + scaled.width);
          var cropB = Math.min(b.y + b.h, photoY + scaled.height);
          var cropW = cropR - cropX;
          var cropH = cropB - cropY;

          if (cropW <= 0 || cropH <= 0) { resolve(null); return; }

          /* Convertir crop region a píxeles de la imagen original */
          var svgToImg = state.imageNaturalWidth / scaled.width;
          var srcX = (cropX - photoX) * svgToImg;
          var srcY = (cropY - photoY) * svgToImg;
          var srcW = cropW * svgToImg;
          var srcH = cropH * svgToImg;

          /* Factor de escala para la salida: queremos el area de impresión
             a la resolución nativa de la foto (alta calidad para imprimir) */
          var outputW = Math.round(srcW);
          var outputH = Math.round(srcH);
          /* Limite de salida. 2800px cubre impresion a 300dpi sobre la
             cara de una carcasa; por encima de ~16.7 MP Safari iOS puede
             devolver un canvas en blanco sin lanzar error. */
          var MAX_PRINT_SIDE = 2800;
          if (outputW > MAX_PRINT_SIDE) {
            var ratio = MAX_PRINT_SIDE / outputW;
            outputW = MAX_PRINT_SIDE;
            outputH = Math.round(outputH * ratio);
          }
          if (outputH > MAX_PRINT_SIDE) {
            var ratioH = MAX_PRINT_SIDE / outputH;
            outputH = MAX_PRINT_SIDE;
            outputW = Math.round(outputW * ratioH);
          }

          /* Se lee el archivo ORIGINAL, no el preview reducido. */
          var printUrl = URL.createObjectURL(state.originalFile);
          var img = new Image();
          img.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = outputW;
            canvas.height = outputH;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img,
              srcX, srcY, srcW, srcH,
              0, 0, outputW, outputH
            );
            URL.revokeObjectURL(printUrl);

            var out = canvas.toDataURL('image/jpeg', 0.92);

            /* Canvas en blanco (limite de memoria del navegador):
               mejor no enviar nada que enviar una imagen vacia. */
            if (!out || out.length < 2048) { resolve(null); return; }

            resolve(out);
          };
          img.onerror = function () {
            URL.revokeObjectURL(printUrl);
            resolve(null);
          };
          img.src = printUrl;
        } catch (_) {
          resolve(null);
        }
      });
    }

    /* ── helper: convert data URL to File for FormData upload ── */
    function dataUrlToFile(dataUrl, filename, overrideMime) {
      var arr = dataUrl.split(',');
      var mime = overrideMime || arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) { u8arr[n] = bstr.charCodeAt(n); }
      return new File([u8arr], filename, { type: mime });
    }

    /* ── helper: collect form data for /cart/add.js (multipart) ── */
    function collectCartFormData(previewFile, printFile) {
      var fd = new FormData(form);

      /* Eliminar la foto original — ya se envía recortada en "Imagen para impresión" */
      fd.delete('properties[Foto personalizada]');

      /* Marca y modelo visibles en carrito y checkout */
      if (state.brandName) fd.set('properties[Marca]', state.brandName);
      if (state.modelName) fd.set('properties[Modelo]', state.modelName);
      /* Preview del mockup (carcasa + foto posicionada, 600px) */
      if (previewFile) fd.set('properties[Preview diseño]', previewFile);
      /* Imagen print-ready (foto recortada al área de impresión, alta res) */
      if (printFile) fd.set('properties[Imagen para impresión]', printFile);
      return fd;
    }

    /* ── helper: generate preview + print-ready images ── */
    function generateOrderImages() {
      return Promise.all([
        captureMockupPreview(),
        capturePrintReady()
      ]).then(function (results) {
        var previewDataUrl = results[0];
        var printDataUrl = results[1];
        var previewFile = previewDataUrl
          ? dataUrlToFile(previewDataUrl, 'preview-diseno.jpg')
          : null;
        var printFile = printDataUrl
          ? dataUrlToFile(printDataUrl, 'imagen-impresion.jpg')
          : null;
        return { previewFile: previewFile, printFile: printFile };
      });
    }

    /* ── helper: validate before any cart action ── */
    function validateBeforeAdd() {
      if (!state.brandSelected || !state.modelSelected) {
        if (modelError) modelError.hidden = false;
        setStep(1, { scroll: true });
        return false;
      }
      if (!state.hasPhoto) {
        setStep(2, { scroll: true });
        fileInput.click();
        return false;
      }
      if (!state.designConfirmed) {
        setStep(2, { scroll: true });
        return false;
      }
      return true;
    }

    /* ── helper: update Dawn cart icon badge via Section Rendering API ── */
    function refreshCartBadge() {
      fetch('/?sections=cart-icon-bubble')
        .then((r) => r.json())
        .then((sections) => {
          const iconEl = document.getElementById('cart-icon-bubble');
          if (iconEl && sections['cart-icon-bubble']) {
            iconEl.innerHTML = sections['cart-icon-bubble'];
          }
        })
        .catch(() => {});
    }

    /* ── "Comprar" (submit) → add to cart then redirect to checkout ── */
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!validateBeforeAdd()) return;

      submit.disabled = true;
      const prevLabel = submitLabel ? submitLabel.textContent : '';
      if (submitLabel) submitLabel.textContent = 'Procesando…';

      generateOrderImages().then(function (images) {
        fetch('/cart/add.js', {
          method: 'POST',
          body: collectCartFormData(images.previewFile, images.printFile)
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart-error');
          window.location.href = '/checkout';
        })
        .catch(function () {
          submit.disabled = false;
          if (submitLabel) submitLabel.textContent = prevLabel;
          alert('Error al agregar al carrito. Intenta de nuevo.');
        });
      });
    });

    /* ── "Agregar al carrito" → add to cart, stay on page ── */
    if (addCartBtn) {
      addCartBtn.addEventListener('click', () => {
        if (!validateBeforeAdd()) return;

        addCartBtn.disabled = true;
        const btnLabel = addCartBtn.querySelector('span');
        const prevText = btnLabel ? btnLabel.textContent : '';
        if (btnLabel) btnLabel.textContent = 'Agregando…';

        generateOrderImages().then(function (images) {
          fetch('/cart/add.js', {
            method: 'POST',
            body: collectCartFormData(images.previewFile, images.printFile)
          })
          .then(function (res) {
            if (!res.ok) throw new Error('cart-error');
            addCartBtn.disabled = false;
            if (btnLabel) btnLabel.textContent = prevText;

            /* show feedback */
            if (cartFeedback) {
              cartFeedback.classList.add('is-visible');
              setTimeout(() => {
                cartFeedback.classList.remove('is-visible');
              }, 3000);
            }

            /* update cart icon badge (Dawn Section Rendering API) */
            refreshCartBadge();
          })
          .catch(function () {
            addCartBtn.disabled = false;
            if (btnLabel) btnLabel.textContent = prevText;
            alert('Error al agregar al carrito. Intenta de nuevo.');
          });
        }); /* generateOrderImages */
      });
    }

    const dragTarget =
      dragSurface ||
      caseSvg;

    let dragRect = null;
    let dragRaf = null;
    let lastPointerX = 0;
    let lastPointerY = 0;

    dragTarget.addEventListener(
      'pointerdown',
      (event) => {
        if (
          !state.hasPhoto ||
          state.editorLocked
        ) return;

        state.dragging = true;
        state.pointerId = event.pointerId;

        state.pointerStartX =
          event.clientX;

        state.pointerStartY =
          event.clientY;

        state.startDx =
          state.dx;

        state.startDy =
          state.dy;

        /* PERF: el rect se mide una vez por gesto. Antes se llamaba
           getBoundingClientRect() en cada pointermove, forzando layout
           sincronico decenas de veces por segundo. */
        dragRect = caseSvg.getBoundingClientRect();

        caseSvg.classList.add(
          'is-dragging'
        );

        document.body.classList.add('cc-dragging');

        dragTarget.setPointerCapture(
          event.pointerId
        );

        event.preventDefault();
      }
    );

    dragTarget.addEventListener(
      'pointermove',
      (event) => {
        if (
          !state.dragging ||
          event.pointerId !== state.pointerId
        ) return;

        lastPointerX = event.clientX;
        lastPointerY = event.clientY;

        /* Un solo recalculo por frame, no uno por evento. */
        if (dragRaf !== null) return;

        dragRaf = requestAnimationFrame(() => {
          dragRaf = null;

          if (!state.dragging || !dragRect) return;

          state.dx =
            state.startDx +
            (lastPointerX - state.pointerStartX) *
            (360 / dragRect.width);

          state.dy =
            state.startDy +
            (lastPointerY - state.pointerStartY) *
            (760 / dragRect.height);

          renderPhoto();
        });
      },
      { passive: true }
    );

    function stopDragging(event) {
      if (!state.dragging) return;

      if (
        event &&
        state.pointerId !== null &&
        event.pointerId !== state.pointerId
      ) return;

      state.dragging = false;

      if (dragRaf !== null) {
        cancelAnimationFrame(dragRaf);
        dragRaf = null;
      }

      dragRect = null;

      caseSvg.classList.remove(
        'is-dragging'
      );

      document.body.classList.remove('cc-dragging');

      try {
        if (state.pointerId !== null) {
          dragTarget.releasePointerCapture(
            state.pointerId
          );
        }
      } catch (_) {}

      state.pointerId = null;
    }

    dragTarget.addEventListener(
      'pointerup',
      stopDragging
    );

    dragTarget.addEventListener(
      'pointercancel',
      stopDragging
    );

    /* ── Pinch-to-zoom (two-finger gesture on touch) ─────────── */
    (function initPinchZoom() {
      var pinchStartDist = 0;
      var pinchStartZoom = 1;
      var isPinching = false;

      function getTouchDist(t1, t2) {
        var dx = t1.clientX - t2.clientX;
        var dy = t1.clientY - t2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      caseSvg.addEventListener('touchstart', function(e) {
        if (e.touches.length === 2 && state.hasPhoto && !state.editorLocked) {
          isPinching = true;
          document.body.classList.add('cc-dragging');
          pinchStartDist = getTouchDist(e.touches[0], e.touches[1]);
          pinchStartZoom = state.zoom;
          stopDragging({ pointerId: state.pointerId });
          e.preventDefault();
        }
      }, { passive: false });

      caseSvg.addEventListener('touchmove', function(e) {
        if (isPinching && e.touches.length === 2) {
          var dist = getTouchDist(e.touches[0], e.touches[1]);
          var scale = dist / pinchStartDist;
          setZoom(pinchStartZoom * scale);
          e.preventDefault();
        }
      }, { passive: false });

      caseSvg.addEventListener('touchend', function() {
        isPinching = false;
        document.body.classList.remove('cc-dragging');
      });

      caseSvg.addEventListener('touchcancel', function() {
        isPinching = false;
        document.body.classList.remove('cc-dragging');
      });
    })();

    const shouldPreselect =
      Boolean(deepLinkedVariant) ||
      !requireManualChoice;

    if (deepLinkedBrand) {
      /* ── Auto-seleccionar marca desde ?brand=  ───────────────── */
      selectBrand(deepLinkedBrand, {
        resetModel: true,
        openModels: true
      });

      state.step =
        window.innerWidth <= 1023
          ? 2
          : 1;

    } else if (
      shouldPreselect &&
      currentOption
    ) {
      const initialBrand =
        currentOption.dataset.brand ||
        inferBrand(
          currentOption.dataset.modelName
        );

      selectBrand(initialBrand, {
        resetModel: false,
        openModels: false
      });

      setModelFromOption(
        currentOption,
        {
          advance: false
        }
      );

      state.step =
        window.innerWidth <= 1023
          ? 2
          : 1;
    } else {
      state.brandSelected = false;
      state.brandName = '';

      state.modelSelected = false;
      state.modelName = '';
      state.deviceKey = '';
      state.variantId = '';

      search.value = '';

      setModelControlEnabled(false);
      updateBrandUi();
      updateModelText();
      updateDeviceProperties();
    }

    state.geometry = getGeometry(
      root,
      state.modelName || currentModel
    );

    renderGeometry();
    setEditorLocked(false);

    setStep(
      state.step,
      {
        scroll: false
      }
    );
  }

  /* Expone el catálogo de modelos y la geometría de cámara para otras
     secciones (ej. página de diseños ya hechos), sin duplicar los datos. */
  window.CCDevices = {
    catalog: MODEL_CATALOG,
    brandPriority: BRAND_PRIORITY,
    inferBrand: inferBrand,
    getGeometry: function (modelName, brand) {
      return getGeometry({ dataset: { productTitle: brand || '' } }, modelName);
    }
  };
  document.dispatchEvent(new CustomEvent('cc:devices:ready'));

  function boot(scope = document) {
    qsa(scope, '[data-cc-customizer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
